// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   xelence · report viewer
   Quiet, dense, paper-ledger.
   ───────────────────────────────────────────────────────────── */

:root {
  /* —— ivory (default light) —— */
  --bg:           #f1ece0;          /* paper-cream */
  --bg-elev:      #f7f3e8;          /* slightly lifted */
  --bg-sunk:      #e9e3d4;          /* sunken (hover) */
  --rule:         #d8d1bd;          /* hairline rules */
  --rule-soft:    #e2dccb;
  --ink:          #2a2d33;          /* graphite — primary text */
  --ink-2:        #4a4d54;          /* secondary */
  --ink-3:        #7a7669;          /* muted (labels, units) */
  --ink-4:        #a8a294;          /* tertiary (placeholder, tree lines) */

  --match:        #486a3a;          /* oklch(.55 .09 145) — green */
  --match-bg:     #dfe4d2;
  --diff:         #a14338;          /* oklch(.5 .14 28) — red */
  --diff-bg:      #ecd9d3;
  --override:     #8a6a1f;          /* oklch(.55 .12 80) — amber */
  --override-bg:  #ecdfbf;
  --accent:       #355c7d;          /* deep ink-blue, used sparingly */

  --row-h:        28px;
  --mono: 'JetBrains Mono', ui-monospace, SF Mono, Menlo, monospace;
  --sans: 'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif;

  --rail-w-comments: 320px;
  --rail-w-audit:    300px;
}

[data-theme="paper"] {
  --bg:           #f1ece0;
  --bg-elev:      #f7f3e8;
  --bg-sunk:      #e9e3d4;
  --rule:         #d8d1bd;
  --rule-soft:    #e2dccb;
  --ink:          #2a2d33;
  --ink-2:        #4a4d54;
  --ink-3:        #7a7669;
  --ink-4:        #a8a294;
  --match:        #486a3a;
  --match-bg:     #dfe4d2;
  --diff:         #a14338;
  --diff-bg:      #ecd9d3;
  --override:     #8a6a1f;
  --override-bg:  #ecdfbf;
  --accent:       #355c7d;
}

[data-theme="light"] {
  --bg:           #eef0f4;
  --bg-elev:      #f6f7f9;
  --bg-sunk:      #e3e6ec;
  --rule:         #d2d6de;
  --rule-soft:    #dee2e9;
  --ink:          #1f2329;
  --ink-2:        #404550;
  --ink-3:        #6a6f7a;
  --ink-4:        #a4a8b1;
  --match:        #2f6a3a;
  --match-bg:     #d8e7d8;
  --diff:         #9a3a30;
  --diff-bg:      #ecd6d2;
  --override:     #7a5e1a;
  --override-bg:  #ecdfbf;
  --accent:       #355c7d;
}

[data-theme="dark"] {
  --bg:           #14161a;
  --bg-elev:      #1c1f24;
  --bg-sunk:      #0f1115;
  --rule:         #2a2e36;
  --rule-soft:    #22262d;
  --ink:          #d8d4c8;
  --ink-2:        #aaa69a;
  --ink-3:        #7a766a;
  --ink-4:        #555148;
  --match:        #8ab37a;
  --match-bg:     #1f2a1c;
  --diff:         #d68a80;
  --diff-bg:      #2c1c1a;
  --override:     #c9a55c;
  --override-bg:  #2a2418;
  --accent:       #7aa3c4;
}

* { box-sizing: border-box; }
html, body, #root { height: 100%; margin: 0; }
body {
  background: var(--bg);
  color: var(--ink);
  font-family: var(--sans);
  font-size: 12.5px;
  line-height: 1.4;
  font-feature-settings: 'cv11', 'ss01';
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
::selection { background: rgba(53,92,125,.22); }

button, input, select { font-family: inherit; color: inherit; }
button { background: none; border: 0; padding: 0; cursor: pointer; }

/* ─────────── Nav rail (shared) ─────────── */
.shell {
  display: grid;
  grid-template-columns: 56px 1fr;
  height: 100vh;
  overflow: hidden;
}
.navrail {
  background: var(--bg-elev);
  border-right: 1px solid var(--rule);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 8px 0;
  gap: 2px;
  overflow: hidden;
}
.nav-brand {
  height: 32px;
  display: flex; align-items: center; justify-content: center;
  font-family: var(--mono); font-weight: 700; font-size: 14px;
  color: var(--ink);
  letter-spacing: .04em;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--rule-soft);
  padding-bottom: 8px;
}
.nav-item {
  position: relative;
  height: 44px;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 1px;
  text-decoration: none;
  color: var(--ink-3);
  font-size: 9.5px;
  letter-spacing: .04em;
  text-transform: uppercase;
  border-left: 2px solid transparent;
  margin-right: 0;
}
.nav-item .g {
  font-family: var(--mono); font-size: 16px;
  color: var(--ink-2);
  line-height: 1;
}
.nav-item .l { font-size: 9.5px; color: var(--ink-3); }
.nav-item:hover { background: var(--bg-sunk); color: var(--ink); }
.nav-item:hover .g { color: var(--ink); }
.nav-item.active {
  background: var(--bg);
  border-left-color: var(--accent);
}
.nav-item.active .g { color: var(--ink); }
.nav-item.active .l { color: var(--ink); font-weight: 500; }
.nav-item.soon { opacity: .55; }
.nav-item .badge {
  position: absolute; top: 4px; right: 4px;
  font-family: var(--mono); font-size: 8.5px;
  color: var(--ink-4);
  border: 1px solid var(--rule);
  border-radius: 2px;
  padding: 0 3px;
  background: var(--bg);
  text-transform: lowercase;
}

/* ─────────── App shell ─────────── */
.app {
  display: grid;
  grid-template-rows: 36px 44px 32px 1fr;
  grid-template-columns: 1fr;
  height: 100vh;
  overflow: hidden;
}
.app[data-comments="1"][data-audit="1"] .body {
  grid-template-columns: 1fr var(--rail-w-comments) var(--rail-w-audit);
}
.app[data-comments="1"][data-audit="0"] .body {
  grid-template-columns: 1fr var(--rail-w-comments);
}
.app[data-comments="0"][data-audit="1"] .body {
  grid-template-columns: 1fr var(--rail-w-audit);
}
.app[data-comments="0"][data-audit="0"] .body {
  grid-template-columns: 1fr;
}

/* ─────────── Top bar (title strip) ─────────── */
.titlebar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 12px;
  border-bottom: 1px solid var(--rule);
  background: var(--bg-elev);
  font-size: 11.5px;
  color: var(--ink-3);
  letter-spacing: .02em;
}
.titlebar .brand {
  font-weight: 600;
  color: var(--ink);
  letter-spacing: .04em;
  font-size: 11.5px;
  text-transform: uppercase;
}
.titlebar .crumb { color: var(--ink-3); }
.titlebar .crumb b { color: var(--ink-2); font-weight: 500; }
.titlebar .sep { color: var(--ink-4); }
.titlebar .right { margin-left: auto; display: flex; align-items: center; gap: 14px; }
.titlebar .stat { display: flex; gap: 6px; align-items: baseline; }
.titlebar .stat .k { color: var(--ink-4); font-size: 10.5px; text-transform: uppercase; letter-spacing: .06em; }
.titlebar .stat .v { font-family: var(--mono); font-size: 11.5px; color: var(--ink-2); font-feature-settings: 'tnum', 'zero'; }

/* ─────────── Switcher row ─────────── */
.switcher {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--rule);
  background: var(--bg);
  padding: 0 12px;
  gap: 0;
}
.sw {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  padding: 0 14px;
  border-right: 1px solid var(--rule-soft);
  cursor: pointer;
  position: relative;
}
.sw:first-child { padding-left: 0; }
.sw:hover { background: var(--bg-sunk); }
.sw .lbl {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: .08em;
  color: var(--ink-4);
}
.sw .val {
  font-size: 13px;
  color: var(--ink);
  font-weight: 500;
}
.sw .val .meta {
  color: var(--ink-3);
  font-weight: 400;
  margin-left: 6px;
  font-size: 11.5px;
  font-family: var(--mono);
  font-feature-settings: 'tnum';
}
.sw .caret { color: var(--ink-4); margin-left: 2px; }

.switcher .actions { margin-left: auto; display: flex; align-items: center; gap: 4px; }
.iconbtn {
  display: inline-flex; align-items: center; gap: 6px;
  height: 26px; padding: 0 9px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 11.5px;
  color: var(--ink-2);
}
.iconbtn:hover { background: var(--bg-sunk); border-color: var(--rule-soft); }
.iconbtn .kbd {
  font-family: var(--mono); font-size: 10px;
  color: var(--ink-4);
  border: 1px solid var(--rule);
  border-radius: 3px;
  padding: 1px 4px;
  background: var(--bg-elev);
}

/* ─────────── Diff summary bar ─────────── */
.diffbar {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--rule);
  background: var(--bg-elev);
  font-size: 11.5px;
}
.diffbar .pill {
  display: flex; align-items: center; gap: 7px;
  padding: 0 14px;
  border-right: 1px solid var(--rule-soft);
  cursor: pointer;
  color: var(--ink-3);
  white-space: nowrap;
  transition: background .08s;
}
.diffbar .pill:hover { background: var(--bg-sunk); }
.diffbar .pill[aria-pressed="true"] {
  color: var(--ink);
  background: var(--bg);
  box-shadow: inset 0 -2px 0 var(--ink);
}
.diffbar .pill .dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: var(--ink-4);
}
.diffbar .pill.is-diff   .dot { background: var(--diff); }
.diffbar .pill.is-match  .dot { background: var(--match); }
.diffbar .pill.is-over   .dot { background: var(--override); }
.diffbar .pill .n {
  font-family: var(--mono); font-size: 11px;
  font-feature-settings: 'tnum';
  color: var(--ink-2);
  margin-left: 1px;
}
.diffbar .summary {
  display: flex; align-items: center; gap: 10px;
  padding: 0 14px;
  margin-left: auto;
  color: var(--ink-3);
  border-left: 1px solid var(--rule-soft);
}
.diffbar .summary b { color: var(--ink); font-weight: 500; }
.diffbar .summary .jump {
  display: inline-flex; align-items: center; gap: 4px;
  font-family: var(--mono); font-size: 10.5px; font-feature-settings: 'tnum';
  color: var(--accent);
  padding: 2px 6px;
  border: 1px solid var(--rule);
  border-radius: 3px;
  background: var(--bg);
}
.diffbar .summary .jump:hover { background: var(--bg-sunk); }
.diffbar .search {
  display: flex; align-items: center; gap: 6px;
  padding: 0 12px;
  border-left: 1px solid var(--rule-soft);
}
.diffbar .search input {
  background: transparent;
  border: 0;
  outline: 0;
  width: 160px;
  font-size: 11.5px;
  color: var(--ink);
}
.diffbar .search input::placeholder { color: var(--ink-4); }

/* ─────────── Body / main + rails ─────────── */
.body {
  display: grid;
  height: 100%;
  overflow: hidden;
  border-top: 0;
}
.main {
  overflow: auto;
  background: var(--bg);
  position: relative;
}
.rail {
  border-left: 1px solid var(--rule);
  background: var(--bg-elev);
  overflow: auto;
  display: flex; flex-direction: column;
}
.rail .rail-head {
  position: sticky; top: 0;
  background: var(--bg-elev);
  border-bottom: 1px solid var(--rule);
  padding: 10px 14px 8px;
  display: flex; align-items: baseline; justify-content: space-between;
  z-index: 2;
}
.rail .rail-head .t {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-3);
  font-weight: 600;
}
.rail .rail-head .c {
  font-family: var(--mono); font-size: 10.5px; color: var(--ink-4);
  font-feature-settings: 'tnum';
}

/* ─────────── Tables ─────────── */
.tablewrap {
  padding: 0 0 80px;
}
.table {
  border-bottom: 1px solid var(--rule);
}
.table .thead {
  position: sticky; top: 0;
  z-index: 3;
  display: grid;
  grid-template-columns: 32px 1fr 160px 160px 170px 28px;
  background: var(--bg-elev);
  border-bottom: 1px solid var(--rule);
  border-top: 1px solid var(--rule);
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: .08em;
  color: var(--ink-3);
  height: 26px;
}
.table .thead > div {
  display: flex; align-items: center;
  padding: 0 10px;
  border-right: 1px solid var(--rule-soft);
}
.table .thead > div:last-child { border-right: 0; }
.table .thead .n { justify-content: flex-end; }

.table .tcap {
  display: flex; align-items: baseline; gap: 10px;
  padding: 18px 14px 8px;
  background: var(--bg);
  position: sticky; top: 0;
  z-index: 4;
  border-top: 1px solid var(--rule);
}
.table:first-child .tcap { border-top: 0; }
.table .tcap .num {
  font-family: var(--mono);
  font-size: 10.5px;
  color: var(--ink-4);
  font-feature-settings: 'tnum';
  letter-spacing: .04em;
}
.table .tcap .name {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -.005em;
}
.table .tcap .meta {
  margin-left: auto;
  font-size: 11px;
  color: var(--ink-3);
  font-family: var(--mono);
  font-feature-settings: 'tnum';
}
.table .tcap .meta .k { color: var(--ink-4); }

/* ─── Row ─── */
.row {
  display: grid;
  grid-template-columns: 32px 1fr 160px 160px 170px 28px;
  align-items: center;
  height: var(--row-h);
  border-bottom: 1px solid var(--rule-soft);
  position: relative;
  cursor: default;
  font-size: 12.5px;
}
.row:hover { background: var(--bg-sunk); }
.row.selected { background: var(--bg-sunk); box-shadow: inset 2px 0 0 var(--accent); }

.row > div {
  padding: 0 10px;
  height: 100%;
  display: flex;
  align-items: center;
  border-right: 1px solid transparent;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.row .c-tw {
  justify-content: center;
  padding: 0;
  color: var(--ink-4);
}
.row .c-name { color: var(--ink-2); font-size: 12.5px; }
.row .c-name .lvl0 { color: var(--ink); font-weight: 500; }
.row .c-num,
.row .c-master,
.row .c-diff {
  font-family: var(--mono);
  font-size: 13px;
  font-feature-settings: 'tnum', 'zero';
  font-variant-numeric: tabular-nums;
  justify-content: flex-end;
  color: var(--ink);
  letter-spacing: -.005em;
}
.row .c-master { color: var(--ink-3); font-weight: 400; }
.row .c-diff { font-size: 12px; }
.row .c-diff .pct {
  color: var(--ink-4);
  font-size: 10.5px;
  margin-left: 6px;
  min-width: 48px;
  text-align: right;
  display: inline-block;
}
.row .c-act { padding: 0; justify-content: center; color: var(--ink-4); }
.row .c-act .expand {
  width: 18px; height: 18px;
  display: inline-flex; align-items: center; justify-content: center;
  border-radius: 3px;
  color: var(--ink-3);
  font-family: var(--mono);
  font-size: 11px;
}
.row .c-act .expand:hover { background: var(--bg); color: var(--ink); }

/* status: left bar + tint */
.row.s-match { box-shadow: inset 2px 0 0 var(--match); }
.row.s-match .c-num { color: var(--ink); }
.row.s-match .c-diff { color: var(--match); }

.row.s-diff { background: var(--diff-bg); box-shadow: inset 2px 0 0 var(--diff); }
.row.s-diff:hover { background: color-mix(in oklab, var(--diff-bg) 70%, var(--bg-sunk)); }
.row.s-diff .c-diff { color: var(--diff); font-weight: 500; }

.row.s-over { background: var(--override-bg); box-shadow: inset 2px 0 0 var(--override); }
.row.s-over:hover { background: color-mix(in oklab, var(--override-bg) 70%, var(--bg-sunk)); }
.row.s-over .c-diff { color: var(--override); }

/* tweak dot */
.tw-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--ink-4);
}
.tw-dot.match { background: var(--match); }
.tw-dot.diff { background: var(--diff); }
.tw-dot.over { background: var(--override); }

.row .has-comment {
  width: 14px; height: 14px;
  display: inline-flex; align-items: center; justify-content: center;
  border-radius: 2px;
  color: var(--ink-3);
  font-size: 10px;
  margin-left: 2px;
}
.row .has-comment.on {
  color: var(--accent);
  background: color-mix(in oklab, var(--accent) 10%, transparent);
}

/* ─── Drilldown ─── */
.tree {
  background: var(--bg-elev);
  border-bottom: 1px solid var(--rule-soft);
  font-family: var(--mono);
  font-feature-settings: 'tnum', 'zero';
  font-size: 12px;
}
.tree-row {
  display: grid;
  grid-template-columns: 32px 1fr 160px 160px 170px 28px;
  align-items: center;
  height: 26px;
  color: var(--ink-3);
  border-bottom: 1px solid var(--rule-soft);
}
.tree-row:last-child { border-bottom: 0; }
.tree-row > div {
  padding: 0 10px;
  height: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tree-row .c-num,
.tree-row .c-master,
.tree-row .c-diff {
  justify-content: flex-end;
}
.tree-row .lines {
  color: var(--ink-4);
  font-size: 11px;
  letter-spacing: -.02em;
}
.tree-row .src {
  display: inline-flex; align-items: center; gap: 8px;
  color: var(--ink-2);
}
.tree-row .file {
  display: inline-block;
  padding: 1px 5px;
  border: 1px solid var(--rule);
  border-radius: 3px;
  background: var(--bg);
  font-size: 10.5px;
  color: var(--ink-2);
  letter-spacing: .02em;
}
.tree-row .cell { color: var(--ink-3); font-size: 11.5px; }
.tree-row .desc { color: var(--ink-3); font-family: var(--sans); font-size: 11.5px; margin-left: 4px; }
.tree-row .c-num { color: var(--ink); }
.tree-row .c-master { color: var(--ink-4); }
.tree-row .c-diff { color: var(--ink-4); font-size: 11px; }
.tree-row.t-diff .c-diff { color: var(--diff); }
.tree-row .formula {
  display: inline-flex; align-items: center; gap: 6px;
  color: var(--ink-3);
  font-size: 11.5px;
}
.tree-row .formula .op { color: var(--ink-4); }
.tree-foot {
  display: grid;
  grid-template-columns: 32px 1fr 160px 160px 170px 28px;
  height: 24px;
  align-items: center;
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: .08em;
  color: var(--ink-4);
  border-top: 1px dashed var(--rule);
  background: var(--bg);
}
.tree-foot > div { padding: 0 10px; height: 100%; display: flex; align-items: center; }
.tree-foot .lbl { justify-content: flex-end; color: var(--ink-3); }
.tree-foot .v { font-family: var(--mono); font-feature-settings:'tnum'; color: var(--ink); justify-content: flex-end; font-size: 11.5px; text-transform: none; letter-spacing: 0; }

/* ─── Comments rail ─── */
.cmt {
  padding: 10px 14px 12px;
  border-bottom: 1px solid var(--rule-soft);
  cursor: pointer;
}
.cmt:hover { background: var(--bg-sunk); }
.cmt.active { background: var(--bg-sunk); box-shadow: inset 2px 0 0 var(--accent); }
.cmt .top {
  display: flex; align-items: baseline; justify-content: space-between;
  margin-bottom: 4px;
}
.cmt .row-name {
  font-size: 11.5px;
  font-weight: 500;
  color: var(--ink);
  flex: 1 1;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.cmt .ts {
  font-family: var(--mono); font-size: 10px; font-feature-settings: 'tnum';
  color: var(--ink-4);
  margin-left: 8px;
}
.cmt .body {
  font-size: 11.5px; color: var(--ink-2); line-height: 1.5;
  display: block; overflow: visible;
  height: auto;
}
.cmt .ctx {
  font-family: var(--mono); font-size: 10.5px; font-feature-settings: 'tnum';
  color: var(--ink-3);
  margin-top: 4px;
  display: flex; gap: 8px; align-items: baseline;
}
.cmt .ctx .v { color: var(--ink-2); }
.cmt-empty {
  padding: 24px 14px;
  font-size: 11.5px; color: var(--ink-4);
  text-align: center;
}

/* ─── Audit rail ─── */
.audit-empty {
  padding: 24px 14px;
  font-size: 11.5px; color: var(--ink-4);
  text-align: center;
  line-height: 1.6;
}
.audit-empty .kbd {
  font-family: var(--mono); font-size: 10px;
  color: var(--ink-3);
  border: 1px solid var(--rule);
  border-radius: 3px;
  padding: 1px 5px;
  background: var(--bg);
}
.audit {
  padding: 12px 14px 16px;
}
.audit .h {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);
  font-weight: 600;
  margin: 14px 0 6px;
}
.audit .h:first-child { margin-top: 0; }
.audit .row-title {
  font-size: 13px; color: var(--ink); font-weight: 500;
  margin-bottom: 2px;
  text-wrap: pretty;
}
.audit .row-val {
  font-family: var(--mono); font-size: 18px; color: var(--ink);
  font-feature-settings: 'tnum', 'zero';
  letter-spacing: -.01em;
  margin-bottom: 2px;
}
.audit .row-val.diff { color: var(--diff); }
.audit .row-val.match { color: var(--match); }
.audit .row-sub {
  font-family: var(--mono); font-size: 11px; color: var(--ink-3);
  font-feature-settings: 'tnum';
}
.audit .pathline {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px;
  font-size: 11.5px;
  padding: 4px 0;
  border-bottom: 1px solid var(--rule-soft);
  align-items: baseline;
}
.audit .pathline:last-child { border-bottom: 0; }
.audit .pathline .lbl { color: var(--ink-3); font-family: var(--mono); font-size: 11px; }
.audit .pathline .val { color: var(--ink); font-family: var(--mono); font-size: 11.5px; font-feature-settings: 'tnum'; text-align: right; }
.audit .formline {
  font-family: var(--mono); font-size: 11px;
  color: var(--ink-2);
  background: var(--bg);
  border: 1px solid var(--rule-soft);
  border-radius: 3px;
  padding: 8px 10px;
  line-height: 1.55;
  font-feature-settings: 'tnum';
  white-space: pre-wrap;
}
.audit .formline .op { color: var(--ink-4); }
.audit .formline .file { color: var(--accent); }

/* ─── Status footer ─── */
.statusbar {
  position: fixed; left: 0; right: 0; bottom: 0;
  height: 22px;
  display: flex; align-items: center;
  font-family: var(--mono);
  font-size: 10.5px;
  color: var(--ink-3);
  background: var(--bg-elev);
  border-top: 1px solid var(--rule);
  padding: 0 12px;
  gap: 14px;
  z-index: 50;
  font-feature-settings: 'tnum';
}
.statusbar .sep { color: var(--ink-4); }
.statusbar .right { margin-left: auto; display: flex; gap: 14px; }

/* ─── BOLD variant overrides ─── */
.app[data-variant="bold"] {
  --row-h: 30px;
}
.app[data-variant="bold"] .row.s-match { box-shadow: inset 3px 0 0 var(--match); }
.app[data-variant="bold"] .row.s-diff  { box-shadow: inset 3px 0 0 var(--diff); }
.app[data-variant="bold"] .row.s-over  { box-shadow: inset 3px 0 0 var(--override); }
.app[data-variant="bold"] .table .thead {
  background: var(--ink);
  color: var(--bg);
  border-color: var(--ink);
}
.app[data-variant="bold"] .table .thead > div { border-right-color: rgba(255,255,255,.08); color: var(--bg-sunk); }
.app[data-variant="bold"] .row .c-num { font-weight: 500; }
.app[data-variant="bold"] .titlebar .brand { color: var(--ink); }
.app[data-variant="bold"] .table .tcap {
  border-bottom: 1px solid var(--ink);
}
.app[data-variant="bold"] .row { border-bottom: 1px solid var(--rule); }

/* ─── Density switching ─── */
.app[data-density="compact"]  { --row-h: 24px; }
.app[data-density="regular"]  { --row-h: 28px; }
.app[data-density="comfy"]    { --row-h: 34px; }

.app[data-density="compact"] .row,
.app[data-density="compact"] .tree-row { font-size: 12px; }
.app[data-density="compact"] .row .c-num,
.app[data-density="compact"] .row .c-master { font-size: 12.5px; }
.app[data-density="comfy"]   .row .c-num,
.app[data-density="comfy"]   .row .c-master { font-size: 13.5px; }

/* ─── Misc ─── */
.scroll-shadow {
  position: sticky; top: 0; height: 0; pointer-events: none;
}
.kbd {
  font-family: var(--mono); font-size: 10px;
  color: var(--ink-3);
  border: 1px solid var(--rule);
  border-radius: 3px;
  padding: 1px 4px;
  background: var(--bg);
  display: inline-block;
}

/* ─────────── Upload page ─────────── */
.upload-page {
  display: grid;
  grid-template-rows: 36px auto 1fr;
  height: 100vh;
  overflow: hidden;
}
.upload-body {
  overflow: auto;
  padding: 0 0 60px;
  background: var(--bg);
}
.upload-section {
  border-bottom: 1px solid var(--rule);
}
.us-head {
  display: flex; align-items: baseline; gap: 12px;
  padding: 18px 20px 10px;
  background: var(--bg);
}
.us-head .num {
  font-family: var(--mono); font-size: 10.5px; color: var(--ink-4); font-feature-settings: 'tnum';
  letter-spacing: .04em;
}
.us-head .name {
  font-size: 13.5px; font-weight: 600; color: var(--ink); letter-spacing: -.005em;
}
.us-head .sub {
  font-size: 11.5px; color: var(--ink-3);
}
.us-head .meta {
  margin-left: auto;
  font-family: var(--mono); font-size: 11px; color: var(--ink-3);
  font-feature-settings: 'tnum';
}
.us-head .meta b { color: var(--ink); font-weight: 500; }

.slot-table .thead {
  display: grid;
  grid-template-columns: 24px 110px 1fr 240px 70px 90px 130px 110px;
  background: var(--bg-elev);
  border-top: 1px solid var(--rule);
  border-bottom: 1px solid var(--rule);
  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-3);
  height: 26px;
}
.slot-table .thead > div {
  display: flex; align-items: center; padding: 0 10px;
  border-right: 1px solid var(--rule-soft);
}
.slot-table .thead > div:last-child { border-right: 0; }
.slot-row {
  display: grid;
  grid-template-columns: 24px 110px 1fr 240px 70px 90px 130px 110px;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid var(--rule-soft);
  font-size: 12.5px;
  position: relative;
}
.slot-row:hover { background: var(--bg-sunk); }
.slot-row > div {
  padding: 0 10px;
  height: 100%;
  display: flex; align-items: center;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.slot-row .c-dot { padding: 0; justify-content: center; }
.slot-row .c-dot .d {
  width: 8px; height: 8px; border-radius: 50%;
  background: var(--ink-4);
}
.slot-row.s-ok    .c-dot .d { background: var(--match); }
.slot-row.s-warn  .c-dot .d { background: var(--override); }
.slot-row.s-err   .c-dot .d { background: var(--diff); }
.slot-row.s-empty .c-dot .d { background: transparent; border: 1px dashed var(--ink-4); }
.slot-row.s-planned .c-dot .d { background: var(--ink-4); opacity: .35; }

.slot-row.s-ok    { box-shadow: inset 2px 0 0 var(--match); }
.slot-row.s-warn  { box-shadow: inset 2px 0 0 var(--override); background: var(--override-bg); }
.slot-row.s-warn:hover { background: color-mix(in oklab, var(--override-bg) 70%, var(--bg-sunk)); }
.slot-row.s-err   { box-shadow: inset 2px 0 0 var(--diff); background: var(--diff-bg); }
.slot-row.s-empty { background: var(--bg); }
.slot-row.s-planned { opacity: .55; background: repeating-linear-gradient(135deg, transparent 0 6px, var(--rule-soft) 6px 7px); }

.slot-row .c-name {
  font-family: var(--mono); font-size: 12px; font-feature-settings: 'tnum';
  color: var(--ink); font-weight: 500;
  gap: 8px;
}
.slot-row .req-tag {
  font-family: var(--mono); font-size: 9.5px;
  color: var(--ink-4);
  border: 1px solid var(--rule);
  border-radius: 2px;
  padding: 1px 4px;
  text-transform: uppercase;
  letter-spacing: .04em;
}
.slot-row .req-tag.req { color: var(--diff); border-color: var(--diff); }

.slot-row .c-desc { color: var(--ink-2); font-size: 12px; }
.slot-row .c-file {
  font-family: var(--mono); font-size: 11.5px; font-feature-settings: 'tnum';
  color: var(--ink-2);
}
.slot-row .c-file.empty { color: var(--ink-4); font-style: italic; font-family: var(--sans); }
.slot-row .c-size,
.slot-row .c-sheets,
.slot-row .c-mod {
  font-family: var(--mono); font-size: 11px; font-feature-settings: 'tnum';
  color: var(--ink-3);
}
.slot-row .c-size { justify-content: flex-end; }
.slot-row .c-sheets { color: var(--ink-2); }

.slot-row .c-actions {
  padding: 0 8px;
  justify-content: flex-end;
  gap: 4px;
}
.slot-row .c-actions button {
  padding: 3px 8px;
  border: 1px solid var(--rule);
  border-radius: 3px;
  font-size: 10.5px;
  color: var(--ink-2);
  background: var(--bg);
  font-family: var(--sans);
}
.slot-row .c-actions button:hover { background: var(--bg-sunk); border-color: var(--ink-3); color: var(--ink); }
.slot-row .c-actions button.primary {
  border-color: var(--accent); color: var(--accent);
}
.slot-row .warn-msg {
  margin-left: 8px;
  font-size: 10.5px;
  color: var(--override);
  font-family: var(--mono);
  font-feature-settings: 'tnum';
}
.slot-row .err-msg {
  margin-left: 8px;
  font-size: 10.5px;
  color: var(--diff);
  font-family: var(--mono);
}

/* Master block */
.master-block {
  display: grid;
  grid-template-columns: 32px 1fr 200px 200px;
  align-items: center;
  margin: 0 20px 18px;
  padding: 14px 16px;
  background: var(--bg-elev);
  border: 1px solid var(--rule);
  border-left: 3px solid var(--accent);
  border-radius: 3px;
  gap: 12px;
}
.master-block .glyph {
  font-family: var(--mono); font-size: 18px; color: var(--accent);
  text-align: center;
}
.master-block .name {
  font-size: 13px; font-weight: 600; color: var(--ink);
}
.master-block .name .ver {
  font-family: var(--mono); font-size: 11px; font-feature-settings: 'tnum';
  color: var(--ink-3); margin-left: 8px;
  font-weight: 400;
}
.master-block .sub {
  font-size: 11.5px; color: var(--ink-3); margin-top: 2px;
}
.master-block .stats {
  font-family: var(--mono); font-size: 11px; font-feature-settings: 'tnum';
  color: var(--ink-3);
  display: grid; gap: 2px;
}
.master-block .stats b { color: var(--ink); font-weight: 500; }
.master-block .acts {
  display: flex; gap: 6px; justify-content: flex-end;
}
.master-block .acts button {
  padding: 6px 12px;
  border: 1px solid var(--rule);
  border-radius: 3px;
  font-size: 11.5px;
  color: var(--ink-2);
  background: var(--bg);
}
.master-block .acts button.primary {
  border-color: var(--accent); color: var(--accent);
}
.master-block .acts button:hover { background: var(--bg-sunk); }

/* Rates panel — общий справочник на период */
.rates-panel { margin: 0 20px; border: 1px solid var(--rule); background: var(--bg-elev); }
.rp-head {
  display: flex; align-items: center; gap: 14px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--rule);
  background: linear-gradient(180deg, var(--bg) 0%, var(--bg-elev) 100%);
}
.rp-h1 { font-weight: 600; color: var(--ink); font-size: 13px; }
.rp-h2 { color: var(--ink-3); font-size: 11.5px; font-family: var(--mono); }
.rp-actions { margin-left: auto; display: flex; gap: 6px; }
.rp-actions button {
  height: 26px; padding: 0 10px;
  background: var(--bg); border: 1px solid var(--rule);
  font-size: 11px; color: var(--ink-2); cursor: pointer;
  font-family: var(--mono);
}
.rp-actions button:hover { background: var(--bg-sunk); }
.rp-actions button.primary { background: var(--ink); color: var(--bg); border-color: var(--ink); }
.rates-wide .rwh,
.rates-wide .rwr {
  display: grid;
  grid-template-columns: 64px 1.4fr 90px 90px 80px 80px 80px 80px 1fr 100px;
}
.rates-wide .rwh {
  background: var(--bg);
  border-bottom: 1px solid var(--rule);
  height: 26px;
  font-size: 10px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-4);
}
.rates-wide .rwh > div { display: flex; align-items: center; padding: 0 10px; border-right: 1px solid var(--rule-soft); }
.rates-wide .rwh > div.n { justify-content: flex-end; }
.rates-wide .rwr {
  height: 34px;
  border-bottom: 1px solid var(--rule-soft);
  align-items: center;
  font-size: 12.5px;
}
.rates-wide .rwr:last-child { border-bottom: 0; }
.rates-wide .rwr:hover { background: var(--bg-sunk); }
.rates-wide .rwr > div { padding: 0 10px; height: 100%; display: flex; align-items: center; border-right: 1px solid var(--rule-soft); }
.rates-wide .rwr > div:last-child { border-right: 0; }
.rates-wide .rwr .code { font-family: var(--mono); font-weight: 600; color: var(--ink); }
.rates-wide .rwr .name { color: var(--ink-2); gap: 8px; }
.rates-wide .rwr .name .yoy { font-family: var(--mono); font-size: 10.5px; }
.rates-wide .rwr .v {
  font-family: var(--mono); font-feature-settings: 'tnum'; font-size: 12.5px;
  color: var(--ink); justify-content: flex-end;
}
.rates-wide .rwr .v.curr { font-weight: 600; }
.rates-wide .rwr .v.hist { color: var(--ink-4); font-size: 11.5px; }
.rates-wide .rwr .src { font-size: 11px; color: var(--ink-3); }
.rates-wide .rwr .lock { font-size: 10.5px; color: var(--ink-3); font-family: var(--mono); }
.rates-wide .rwr.editable .v.curr {
  border-bottom: 1px dashed var(--override);
  color: var(--override);
}
.rates-wide .rwr.editable .lock { color: var(--override); }
.rp-foot {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 16px;
  border-top: 1px solid var(--rule);
  background: var(--bg);
  font-size: 11px; color: var(--ink-3);
  font-family: var(--mono); font-feature-settings: 'tnum';
}
.rp-foot b { color: var(--ink-2); font-weight: 500; }
.rp-foot .sep { color: var(--ink-4); }
.rp-foot .meta { margin-left: auto; color: var(--ink-4); }

/* Cluster picker on Upload — bigger, cluster grid */
.cluster-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1px;
  background: var(--rule);
  border-top: 1px solid var(--rule);
  border-bottom: 1px solid var(--rule);
}
.cluster-card {
  padding: 12px 14px;
  background: var(--bg);
  cursor: pointer;
  border-left: 2px solid transparent;
}
.cluster-card:hover { background: var(--bg-sunk); }
.cluster-card.active { background: var(--bg-elev); border-left-color: var(--accent); }
.cluster-card .top {
  display: flex; justify-content: space-between; align-items: baseline;
  margin-bottom: 4px;
}
.cluster-card .label {
  font-family: var(--mono); font-size: 12px; font-weight: 600;
  color: var(--ink);
  font-feature-settings: 'tnum';
}
.cluster-card .progress {
  font-family: var(--mono); font-size: 10.5px; font-feature-settings: 'tnum';
  color: var(--ink-3);
}
.cluster-card.complete .progress { color: var(--match); }
.cluster-card.partial  .progress { color: var(--override); }
.cluster-card .company { font-size: 11.5px; color: var(--ink-2); }
.cluster-card .period { font-size: 10.5px; color: var(--ink-4); font-family: var(--mono); }
.cluster-card .bar {
  height: 2px; background: var(--rule); margin-top: 8px;
  overflow: hidden;
}
.cluster-card .bar-fill {
  height: 100%; background: var(--match);
}
.cluster-card.partial .bar-fill { background: var(--override); }

/* Defaults strip */
.defaults-strip {
  margin: 0 20px;
  padding: 12px 14px;
  background: var(--bg-elev);
  border: 1px solid var(--rule);
  border-radius: 3px;
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 12px;
}
.defaults-strip label {
  display: flex; align-items: center; gap: 8px;
  color: var(--ink-2);
  cursor: pointer;
}
.defaults-strip input[type="checkbox"] {
  width: 14px; height: 14px;
  accent-color: var(--accent);
}
.defaults-strip .meta {
  margin-left: auto;
  font-family: var(--mono); font-size: 10.5px; color: var(--ink-3);
  font-feature-settings: 'tnum';
}

/* Drop zone overlay */
.drop-overlay {
  position: fixed; inset: 0;
  background: color-mix(in oklab, var(--accent) 14%, var(--bg) 50%);
  z-index: 200;
  display: flex; align-items: center; justify-content: center;
  pointer-events: none;
  animation: dropFade .14s ease-out;
}
@keyframes dropFade { from { opacity: 0; } to { opacity: 1; } }
.drop-overlay::before {
  content: ''; position: absolute; inset: 24px;
  border: 2.5px dashed var(--accent);
  border-radius: 6px;
  background: color-mix(in oklab, var(--accent) 4%, var(--bg-elev));
}
.drop-overlay .drop-card {
  position: relative;
  text-align: center;
  padding: 32px 56px;
  background: var(--bg-elev);
  border: 1px solid var(--rule);
  border-radius: 4px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, .14);
  max-width: 520px;
}
.drop-overlay .dco-glyph {
  font-family: var(--mono);
  font-size: 56px; line-height: 1;
  color: var(--accent);
  margin-bottom: 14px;
}
.drop-overlay .dco-title {
  font-size: 18px; font-weight: 600; color: var(--ink);
  letter-spacing: -.005em;
  margin-bottom: 6px;
}
.drop-overlay .dco-sub {
  font-size: 12.5px; color: var(--ink-3); line-height: 1.55;
}
.drop-overlay .dco-sub b { color: var(--ink); font-weight: 500; font-family: var(--mono); }

/* File preview popover (Upload) */
.file-pop {
  position: fixed;
  z-index: 150;
  background: var(--bg-elev);
  border: 1px solid var(--rule);
  border-radius: 4px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, .14), 0 2px 8px rgba(0, 0, 0, .08);
  pointer-events: none;
  animation: fpFade .12s ease-out;
}
@keyframes fpFade {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}
.file-pop .fph {
  display: flex; align-items: baseline; gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--rule);
  background: var(--bg);
  border-radius: 4px 4px 0 0;
}
.file-pop .fph .fname {
  font-family: var(--mono); font-size: 12px; font-weight: 600;
  color: var(--ink); font-feature-settings: 'tnum';
}
.file-pop .fph .fmeta {
  margin-left: auto;
  font-size: 10.5px; color: var(--ink-3);
  font-family: var(--mono); font-feature-settings: 'tnum';
}
.file-pop .fph .fmeta b { color: var(--ink); font-weight: 500; }
.file-pop .fwarn {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 14px;
  background: color-mix(in oklab, var(--diff) 10%, var(--bg-elev));
  border-bottom: 1px solid var(--rule-soft);
  font-size: 11px;
  color: var(--diff);
}
.file-pop .fwarn .dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--diff);
}
.file-pop .fgrid {
  width: 100%;
  border-collapse: collapse;
  font-feature-settings: 'tnum';
}
.file-pop .fgrid th, .file-pop .fgrid td {
  padding: 5px 10px;
  border-right: 1px solid var(--rule-soft);
  border-bottom: 1px solid var(--rule-soft);
  font-size: 11px;
  color: var(--ink-2);
  font-family: var(--mono);
  white-space: nowrap;
  text-align: left;
}
.file-pop .fgrid th:last-child, .file-pop .fgrid td:last-child { border-right: 0; }
.file-pop .fgrid tbody tr:last-child td { border-bottom: 0; }
.file-pop .fgrid th {
  background: var(--bg);
  color: var(--ink-4);
  font-size: 10px; font-weight: 500;
  text-transform: uppercase;
  letter-spacing: .05em;
}
.file-pop .fgrid td.rh {
  color: var(--ink-4);
  font-size: 10px;
  width: 36px;
  background: var(--bg);
  text-align: right;
}
.file-pop .fgrid td.n { text-align: right; color: var(--ink); }
.file-pop .fpf {
  display: flex; align-items: center;
  padding: 8px 14px;
  border-top: 1px solid var(--rule);
  font-size: 10.5px;
  color: var(--ink-3);
  font-family: var(--mono);
  font-feature-settings: 'tnum';
  background: var(--bg);
  border-radius: 0 0 4px 4px;
}

/* scrollbar - ledger feel */
.main::-webkit-scrollbar, .rail::-webkit-scrollbar { width: 10px; height: 10px; }
.main::-webkit-scrollbar-thumb, .rail::-webkit-scrollbar-thumb {
  background: var(--rule);
  border: 2px solid var(--bg);
  border-radius: 6px;
}
.main::-webkit-scrollbar-track, .rail::-webkit-scrollbar-track { background: transparent; }
`, "",{"version":3,"sources":["webpack://./src/v2/styles.css"],"names":[],"mappings":"AAAA;;;kEAGkE;;AAElE;EACE,gCAAgC;EAChC,uBAAuB,WAAW,gBAAgB;EAClD,uBAAuB,WAAW,oBAAoB;EACtD,uBAAuB,WAAW,mBAAmB;EACrD,uBAAuB,WAAW,mBAAmB;EACrD,uBAAuB;EACvB,uBAAuB,WAAW,4BAA4B;EAC9D,uBAAuB,WAAW,cAAc;EAChD,uBAAuB,WAAW,0BAA0B;EAC5D,uBAAuB,WAAW,uCAAuC;;EAEzE,uBAAuB,WAAW,+BAA+B;EACjE,uBAAuB;EACvB,uBAAuB,WAAW,2BAA2B;EAC7D,uBAAuB;EACvB,uBAAuB,WAAW,8BAA8B;EAChE,uBAAuB;EACvB,uBAAuB,WAAW,kCAAkC;;EAEpE,oBAAoB;EACpB,iEAAiE;EACjE,oEAAoE;;EAEpE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,IAAI,sBAAsB,EAAE;AAC5B,oBAAoB,YAAY,EAAE,SAAS,EAAE;AAC7C;EACE,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;AACpC;AACA,cAAc,+BAA+B,EAAE;;AAE/C,wBAAwB,oBAAoB,EAAE,cAAc,EAAE;AAC9D,SAAS,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,eAAe,EAAE;;AAEnE,8CAA8C;AAC9C;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,wBAAwB,EAAE,gBAAgB,EAAE,eAAe;EAC3D,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB;EACnF,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,wBAAwB,EAAE,eAAe;EACzC,mBAAmB;EACnB,cAAc;AAChB;AACA,eAAe,gBAAgB,EAAE,mBAAmB,EAAE;AACtD,kBAAkB,0BAA0B,EAAE,iBAAiB,EAAE;AACjE,qBAAqB,iBAAiB,EAAE;AACxC;EACE,qBAAqB;EACrB,gCAAgC;AAClC;AACA,sBAAsB,iBAAiB,EAAE;AACzC,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE;AAC3D,iBAAiB,YAAY,EAAE;AAC/B;EACE,kBAAkB,EAAE,QAAQ,EAAE,UAAU;EACxC,wBAAwB,EAAE,gBAAgB;EAC1C,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qEAAqE;AACvE;AACA;EACE,iDAAiD;AACnD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oCAAoC;EACpC,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA,mBAAmB,mBAAmB,EAAE;AACxC,qBAAqB,mBAAmB,EAAE,gBAAgB,EAAE;AAC5D,iBAAiB,mBAAmB,EAAE;AACtC,mBAAmB,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACrF,kBAAkB,aAAa,EAAE,QAAQ,EAAE,qBAAqB,EAAE;AAClE,qBAAqB,mBAAmB,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AAC/G,qBAAqB,wBAAwB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,qCAAqC,EAAE;;AAE9H,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,MAAM;AACR;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,kBAAkB;AACpB;AACA,kBAAkB,eAAe,EAAE;AACnC,YAAY,0BAA0B,EAAE;AACxC;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,6BAA6B;AAC/B;AACA,aAAa,mBAAmB,EAAE,gBAAgB,EAAE;;AAEpD,qBAAqB,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,YAAY,EAAE,cAAc;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,iBAAiB,0BAA0B,EAAE,8BAA8B,EAAE;AAC7E;EACE,wBAAwB,EAAE,eAAe;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,oBAAoB;EACpB,oCAAoC;EACpC,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA,uBAAuB,0BAA0B,EAAE;AACnD;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qCAAqC;AACvC;AACA;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,wBAAwB;AAC1B;AACA,gCAAgC,uBAAuB,EAAE;AACzD,gCAAgC,wBAAwB,EAAE;AAC1D,gCAAgC,2BAA2B,EAAE;AAC7D;EACE,wBAAwB,EAAE,eAAe;EACzC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;AACA,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE;AAC3D;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,wBAAwB,EAAE,iBAAiB,EAAE,6BAA6B;EAC1E,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;AACvB;AACA,gCAAgC,0BAA0B,EAAE;AAC5D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA,sCAAsC,mBAAmB,EAAE;;AAE3D,gDAAgD;AAChD;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,aAAa,EAAE,sBAAsB;AACvC;AACA;EACE,gBAAgB,EAAE,MAAM;EACxB,0BAA0B;EAC1B,oCAAoC;EACpC,sBAAsB;EACtB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B;EACpE,UAAU;AACZ;AACA;EACE,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB;EACxF,gBAAgB;AAClB;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,mBAAmB;EAChE,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB,EAAE,MAAM;EACxB,UAAU;EACV,aAAa;EACb,sDAAsD;EACtD,0BAA0B;EAC1B,oCAAoC;EACpC,iCAAiC;EACjC,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa,EAAE,mBAAmB;EAClC,eAAe;EACf,wCAAwC;AAC1C;AACA,iCAAiC,eAAe,EAAE;AAClD,mBAAmB,yBAAyB,EAAE;;AAE9C;EACE,aAAa,EAAE,qBAAqB,EAAE,SAAS;EAC/C,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB,EAAE,MAAM;EACxB,UAAU;EACV,iCAAiC;AACnC;AACA,2BAA2B,aAAa,EAAE;AAC1C;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;AAC/B;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C,gBAAgB;AAChB;EACE,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA,aAAa,0BAA0B,EAAE;AACzC,gBAAgB,0BAA0B,EAAE,uCAAuC,EAAE;;AAErF;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;AACA,eAAe,mBAAmB,EAAE,iBAAiB,EAAE;AACvD,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE;AAC1D;;;EAGE,wBAAwB;EACxB,eAAe;EACf,qCAAqC;EACrC,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;AACzB;AACA,iBAAiB,mBAAmB,EAAE,gBAAgB,EAAE;AACxD,eAAe,eAAe,EAAE;AAChC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA,cAAc,UAAU,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACxE;EACE,WAAW,EAAE,YAAY;EACzB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;AACjB;AACA,4BAA4B,qBAAqB,EAAE,iBAAiB,EAAE;;AAEtE,4BAA4B;AAC5B,eAAe,sCAAsC,EAAE;AACvD,sBAAsB,iBAAiB,EAAE;AACzC,uBAAuB,mBAAmB,EAAE;;AAE5C,cAAc,0BAA0B,EAAE,qCAAqC,EAAE;AACjF,oBAAoB,mEAAmE,EAAE;AACzF,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE;;AAE5D,cAAc,8BAA8B,EAAE,yCAAyC,EAAE;AACzF,oBAAoB,uEAAuE,EAAE;AAC7F,sBAAsB,sBAAsB,EAAE;;AAE9C,cAAc;AACd;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,wBAAwB;AAC1B;AACA,gBAAgB,wBAAwB,EAAE;AAC1C,eAAe,uBAAuB,EAAE;AACxC,eAAe,2BAA2B,EAAE;;AAE5C;EACE,WAAW,EAAE,YAAY;EACzB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,+DAA+D;AACjE;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,wBAAwB;EACxB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;AACA,uBAAuB,gBAAgB,EAAE;AACzC;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;AACA,kBAAkB,mBAAmB,EAAE,iBAAiB,EAAE;AAC1D,kBAAkB,mBAAmB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACtG,mBAAmB,iBAAiB,EAAE;AACtC,sBAAsB,mBAAmB,EAAE;AAC3C,oBAAoB,mBAAmB,EAAE,eAAe,EAAE;AAC1D,2BAA2B,kBAAkB,EAAE;AAC/C;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,mBAAmB;EACnB,iBAAiB;AACnB;AACA,yBAAyB,mBAAmB,EAAE;AAC9C;EACE,aAAa;EACb,sDAAsD;EACtD,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;EAClC,qBAAqB;AACvB;AACA,mBAAmB,eAAe,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACtF,kBAAkB,yBAAyB,EAAE,mBAAmB,EAAE;AAClE,gBAAgB,wBAAwB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE;;AAElL,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,yCAAyC;EACzC,eAAe;AACjB;AACA,aAAa,0BAA0B,EAAE;AACzC,cAAc,0BAA0B,EAAE,uCAAuC,EAAE;AACnF;EACE,aAAa,EAAE,qBAAqB,EAAE,8BAA8B;EACpE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,SAAO;EACP,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,6BAA6B;EACxE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB;EACxD,cAAc,EAAE,iBAAiB;EACjC,YAAY;AACd;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,6BAA6B;EAC1E,mBAAmB;EACnB,eAAe;EACf,aAAa,EAAE,QAAQ,EAAE,qBAAqB;AAChD;AACA,eAAe,mBAAmB,EAAE;AACpC;EACE,kBAAkB;EAClB,iBAAiB,EAAE,mBAAmB;EACtC,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iBAAiB,EAAE,mBAAmB;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,wBAAwB,EAAE,eAAe;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB;EACxF,gBAAgB;EAChB,kBAAkB;AACpB;AACA,wBAAwB,aAAa,EAAE;AACvC;EACE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB;EACpD,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,iBAAiB;EAC5D,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;AACpB;AACA,uBAAuB,kBAAkB,EAAE;AAC3C,wBAAwB,mBAAmB,EAAE;AAC7C;EACE,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,yCAAyC;EACzC,qBAAqB;AACvB;AACA,8BAA8B,gBAAgB,EAAE;AAChD,wBAAwB,mBAAmB,EAAE,wBAAwB,EAAE,eAAe,EAAE;AACxF,wBAAwB,iBAAiB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,iBAAiB,EAAE;AAC1I;EACE,wBAAwB,EAAE,eAAe;EACzC,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,yBAAyB,oBAAoB,EAAE;;AAE/C,0BAA0B;AAC1B;EACE,eAAe,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EAC7C,YAAY;EACZ,aAAa,EAAE,mBAAmB;EAClC,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;EACf,SAAS;EACT,WAAW;EACX,6BAA6B;AAC/B;AACA,kBAAkB,mBAAmB,EAAE;AACvC,oBAAoB,iBAAiB,EAAE,aAAa,EAAE,SAAS,EAAE;;AAEjE,mCAAmC;AACnC;EACE,aAAa;AACf;AACA,yCAAyC,sCAAsC,EAAE;AACjF,yCAAyC,qCAAqC,EAAE;AAChF,yCAAyC,yCAAyC,EAAE;AACpF;EACE,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA,gDAAgD,yCAAyC,EAAE,qBAAqB,EAAE;AAClH,wCAAwC,gBAAgB,EAAE;AAC1D,6CAA6C,iBAAiB,EAAE;AAChE;EACE,mCAAmC;AACrC;AACA,iCAAiC,oCAAoC,EAAE;;AAEvE,8BAA8B;AAC9B,gCAAgC,aAAa,EAAE;AAC/C,gCAAgC,aAAa,EAAE;AAC/C,gCAAgC,aAAa,EAAE;;AAE/C;yCACyC,eAAe,EAAE;AAC1D;8CAC8C,iBAAiB,EAAE;AACjE;8CAC8C,iBAAiB,EAAE;;AAEjE,iBAAiB;AACjB;EACE,gBAAgB,EAAE,MAAM,EAAE,SAAS,EAAE,oBAAoB;AAC3D;AACA;EACE,wBAAwB,EAAE,eAAe;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa,EAAE,qBAAqB,EAAE,SAAS;EAC/C,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,6BAA6B;EAC/F,qBAAqB;AACvB;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,uBAAuB;AACjF;AACA;EACE,iBAAiB,EAAE,mBAAmB;AACxC;AACA;EACE,iBAAiB;EACjB,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;AAC/B;AACA,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE;;AAExD;EACE,aAAa;EACb,iEAAiE;EACjE,0BAA0B;EAC1B,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB;EACnE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,eAAe;EACnD,wCAAwC;AAC1C;AACA,sCAAsC,eAAe,EAAE;AACvD;EACE,aAAa;EACb,iEAAiE;EACjE,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;AACpB;AACA,kBAAkB,0BAA0B,EAAE;AAC9C;EACE,eAAe;EACf,YAAY;EACZ,aAAa,EAAE,mBAAmB;EAClC,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;AAChE;AACA,mBAAmB,UAAU,EAAE,uBAAuB,EAAE;AACxD;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,wBAAwB;AAC1B;AACA,8BAA8B,wBAAwB,EAAE;AACxD,8BAA8B,2BAA2B,EAAE;AAC3D,8BAA8B,uBAAuB,EAAE;AACvD,8BAA8B,uBAAuB,EAAE,+BAA+B,EAAE;AACxF,gCAAgC,wBAAwB,EAAE,YAAY,EAAE;;AAExE,oBAAoB,sCAAsC,EAAE;AAC5D,oBAAoB,yCAAyC,EAAE,8BAA8B,EAAE;AAC/F,yBAAyB,uEAAuE,EAAE;AAClG,oBAAoB,qCAAqC,EAAE,0BAA0B,EAAE;AACvF,oBAAoB,qBAAqB,EAAE;AAC3C,sBAAsB,YAAY,EAAE,0FAA0F,EAAE;;AAEhI;EACE,wBAAwB,EAAE,eAAe,EAAE,6BAA6B;EACxE,iBAAiB,EAAE,gBAAgB;EACnC,QAAQ;AACV;AACA;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA,yBAAyB,kBAAkB,EAAE,yBAAyB,EAAE;;AAExE,oBAAoB,mBAAmB,EAAE,eAAe,EAAE;AAC1D;EACE,wBAAwB,EAAE,iBAAiB,EAAE,6BAA6B;EAC1E,mBAAmB;AACrB;AACA,0BAA0B,mBAAmB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC7F;;;EAGE,wBAAwB,EAAE,eAAe,EAAE,6BAA6B;EACxE,mBAAmB;AACrB;AACA,oBAAoB,yBAAyB,EAAE;AAC/C,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,cAAc;EACd,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA,oCAAoC,0BAA0B,EAAE,0BAA0B,EAAE,iBAAiB,EAAE;AAC/G;EACE,2BAA2B,EAAE,oBAAoB;AACnD;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,oBAAoB;EAC/D,kBAAkB;AACpB;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB;AACtD;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,6BAA6B;EACxE,mBAAmB,EAAE,gBAAgB;EACrC,gBAAgB;AAClB;AACA;EACE,iBAAiB,EAAE,mBAAmB,EAAE,eAAe;AACzD;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,6BAA6B;EACxE,mBAAmB;EACnB,aAAa,EAAE,QAAQ;AACzB;AACA,yBAAyB,iBAAiB,EAAE,gBAAgB,EAAE;AAC9D;EACE,aAAa,EAAE,QAAQ,EAAE,yBAAyB;AACpD;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,2BAA2B,EAAE,oBAAoB;AACnD;AACA,mCAAmC,0BAA0B,EAAE;;AAE/D,6CAA6C;AAC7C,eAAe,cAAc,EAAE,6BAA6B,EAAE,0BAA0B,EAAE;AAC1F;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB;EAClB,oCAAoC;EACpC,sEAAsE;AACxE;AACA,SAAS,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC/D,SAAS,mBAAmB,EAAE,iBAAiB,EAAE,wBAAwB,EAAE;AAC3E,cAAc,iBAAiB,EAAE,aAAa,EAAE,QAAQ,EAAE;AAC1D;EACE,YAAY,EAAE,eAAe;EAC7B,qBAAqB,EAAE,6BAA6B;EACpD,eAAe,EAAE,mBAAmB,EAAE,eAAe;EACrD,wBAAwB;AAC1B;AACA,2BAA2B,0BAA0B,EAAE;AACvD,6BAA6B,sBAAsB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AACjG;;EAEE,aAAa;EACb,yEAAyE;AAC3E;AACA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,YAAY;EACZ,eAAe,EAAE,yBAAyB,EAAE,qBAAqB;EACjE,mBAAmB;AACrB;AACA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,wCAAwC,EAAE;AACxH,2BAA2B,yBAAyB,EAAE;AACtD;EACE,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;AACnB;AACA,8BAA8B,gBAAgB,EAAE;AAChD,yBAAyB,0BAA0B,EAAE;AACrD,yBAAyB,eAAe,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,wCAAwC,EAAE;AACtI,oCAAoC,eAAe,EAAE;AACrD,yBAAyB,wBAAwB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACxF,yBAAyB,mBAAmB,EAAE,QAAQ,EAAE;AACxD,8BAA8B,wBAAwB,EAAE,iBAAiB,EAAE;AAC3E;EACE,wBAAwB,EAAE,6BAA6B,EAAE,iBAAiB;EAC1E,iBAAiB,EAAE,yBAAyB;AAC9C;AACA,2BAA2B,gBAAgB,EAAE;AAC7C,2BAA2B,mBAAmB,EAAE,iBAAiB,EAAE;AACnE,wBAAwB,eAAe,EAAE,mBAAmB,EAAE;AAC9D,yBAAyB,iBAAiB,EAAE,mBAAmB,EAAE,wBAAwB,EAAE;AAC3F;EACE,yCAAyC;EACzC,sBAAsB;AACxB;AACA,kCAAkC,sBAAsB,EAAE;AAC1D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;EACrB,eAAe,EAAE,mBAAmB;EACpC,wBAAwB,EAAE,6BAA6B;AACzD;AACA,aAAa,mBAAmB,EAAE,gBAAgB,EAAE;AACpD,gBAAgB,mBAAmB,EAAE;AACrC,iBAAiB,iBAAiB,EAAE,mBAAmB,EAAE;;AAEzD,oDAAoD;AACpD;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,uBAAuB;EACvB,iCAAiC;EACjC,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kCAAkC;AACpC;AACA,sBAAsB,0BAA0B,EAAE;AAClD,uBAAuB,0BAA0B,EAAE,gCAAgC,EAAE;AACrF;EACE,aAAa,EAAE,8BAA8B,EAAE,qBAAqB;EACpE,kBAAkB;AACpB;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,gBAAgB;EAC3D,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,6BAA6B;EAC1E,mBAAmB;AACrB;AACA,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,sBAAsB,EAAE;AAC3D,yBAAyB,iBAAiB,EAAE,mBAAmB,EAAE;AACjE,wBAAwB,iBAAiB,EAAE,mBAAmB,EAAE,wBAAwB,EAAE;AAC1F;EACE,WAAW,EAAE,uBAAuB,EAAE,eAAe;EACrD,gBAAgB;AAClB;AACA;EACE,YAAY,EAAE,wBAAwB;AACxC;AACA,kCAAkC,2BAA2B,EAAE;;AAE/D,mBAAmB;AACnB;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,wBAAwB,EAAE,iBAAiB,EAAE,mBAAmB;EAChE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,eAAe,EAAE,QAAQ;EACzB,iEAAiE;EACjE,YAAY;EACZ,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,oBAAoB;EACpB,iCAAiC;AACnC;AACA,sBAAsB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC9D;EACE,WAAW,EAAE,kBAAkB,EAAE,WAAW;EAC5C,kCAAkC;EAClC,kBAAkB;EAClB,iEAAiE;AACnE;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,eAAe,EAAE,cAAc;EAC/B,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB;EACpD,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,iBAAiB,EAAE,mBAAmB,EAAE,iBAAiB;AAC3D;AACA,2BAA2B,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;;AAE1F,kCAAkC;AAClC;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,wEAAwE;EACxE,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,aAAa,EAAE,qBAAqB,EAAE,SAAS;EAC/C,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,gBAAgB;EAC3D,iBAAiB,EAAE,6BAA6B;AAClD;AACA;EACE,iBAAiB;EACjB,iBAAiB,EAAE,mBAAmB;EACtC,wBAAwB,EAAE,6BAA6B;AACzD;AACA,0BAA0B,iBAAiB,EAAE,gBAAgB,EAAE;AAC/D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB;EACjB,gEAAgE;EAChE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,yCAAyC;EACzC,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,iEAAiE,eAAe,EAAE;AAClF,0CAA0C,gBAAgB,EAAE;AAC5D;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe,EAAE,gBAAgB;EACjC,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;AACA,wBAAwB,iBAAiB,EAAE,iBAAiB,EAAE;AAC9D;EACE,aAAa,EAAE,mBAAmB;EAClC,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B,qDAAqD,WAAW,EAAE,YAAY,EAAE;AAChF;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA,iEAAiE,uBAAuB,EAAE","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   xelence · report viewer\n   Quiet, dense, paper-ledger.\n   ───────────────────────────────────────────────────────────── */\n\n:root {\n  /* —— ivory (default light) —— */\n  --bg:           #f1ece0;          /* paper-cream */\n  --bg-elev:      #f7f3e8;          /* slightly lifted */\n  --bg-sunk:      #e9e3d4;          /* sunken (hover) */\n  --rule:         #d8d1bd;          /* hairline rules */\n  --rule-soft:    #e2dccb;\n  --ink:          #2a2d33;          /* graphite — primary text */\n  --ink-2:        #4a4d54;          /* secondary */\n  --ink-3:        #7a7669;          /* muted (labels, units) */\n  --ink-4:        #a8a294;          /* tertiary (placeholder, tree lines) */\n\n  --match:        #486a3a;          /* oklch(.55 .09 145) — green */\n  --match-bg:     #dfe4d2;\n  --diff:         #a14338;          /* oklch(.5 .14 28) — red */\n  --diff-bg:      #ecd9d3;\n  --override:     #8a6a1f;          /* oklch(.55 .12 80) — amber */\n  --override-bg:  #ecdfbf;\n  --accent:       #355c7d;          /* deep ink-blue, used sparingly */\n\n  --row-h:        28px;\n  --mono: 'JetBrains Mono', ui-monospace, SF Mono, Menlo, monospace;\n  --sans: 'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif;\n\n  --rail-w-comments: 320px;\n  --rail-w-audit:    300px;\n}\n\n[data-theme=\"paper\"] {\n  --bg:           #f1ece0;\n  --bg-elev:      #f7f3e8;\n  --bg-sunk:      #e9e3d4;\n  --rule:         #d8d1bd;\n  --rule-soft:    #e2dccb;\n  --ink:          #2a2d33;\n  --ink-2:        #4a4d54;\n  --ink-3:        #7a7669;\n  --ink-4:        #a8a294;\n  --match:        #486a3a;\n  --match-bg:     #dfe4d2;\n  --diff:         #a14338;\n  --diff-bg:      #ecd9d3;\n  --override:     #8a6a1f;\n  --override-bg:  #ecdfbf;\n  --accent:       #355c7d;\n}\n\n[data-theme=\"light\"] {\n  --bg:           #eef0f4;\n  --bg-elev:      #f6f7f9;\n  --bg-sunk:      #e3e6ec;\n  --rule:         #d2d6de;\n  --rule-soft:    #dee2e9;\n  --ink:          #1f2329;\n  --ink-2:        #404550;\n  --ink-3:        #6a6f7a;\n  --ink-4:        #a4a8b1;\n  --match:        #2f6a3a;\n  --match-bg:     #d8e7d8;\n  --diff:         #9a3a30;\n  --diff-bg:      #ecd6d2;\n  --override:     #7a5e1a;\n  --override-bg:  #ecdfbf;\n  --accent:       #355c7d;\n}\n\n[data-theme=\"dark\"] {\n  --bg:           #14161a;\n  --bg-elev:      #1c1f24;\n  --bg-sunk:      #0f1115;\n  --rule:         #2a2e36;\n  --rule-soft:    #22262d;\n  --ink:          #d8d4c8;\n  --ink-2:        #aaa69a;\n  --ink-3:        #7a766a;\n  --ink-4:        #555148;\n  --match:        #8ab37a;\n  --match-bg:     #1f2a1c;\n  --diff:         #d68a80;\n  --diff-bg:      #2c1c1a;\n  --override:     #c9a55c;\n  --override-bg:  #2a2418;\n  --accent:       #7aa3c4;\n}\n\n* { box-sizing: border-box; }\nhtml, body, #root { height: 100%; margin: 0; }\nbody {\n  background: var(--bg);\n  color: var(--ink);\n  font-family: var(--sans);\n  font-size: 12.5px;\n  line-height: 1.4;\n  font-feature-settings: 'cv11', 'ss01';\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\n::selection { background: rgba(53,92,125,.22); }\n\nbutton, input, select { font-family: inherit; color: inherit; }\nbutton { background: none; border: 0; padding: 0; cursor: pointer; }\n\n/* ─────────── Nav rail (shared) ─────────── */\n.shell {\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  height: 100vh;\n  overflow: hidden;\n}\n.navrail {\n  background: var(--bg-elev);\n  border-right: 1px solid var(--rule);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 8px 0;\n  gap: 2px;\n  overflow: hidden;\n}\n.nav-brand {\n  height: 32px;\n  display: flex; align-items: center; justify-content: center;\n  font-family: var(--mono); font-weight: 700; font-size: 14px;\n  color: var(--ink);\n  letter-spacing: .04em;\n  margin-bottom: 8px;\n  border-bottom: 1px solid var(--rule-soft);\n  padding-bottom: 8px;\n}\n.nav-item {\n  position: relative;\n  height: 44px;\n  display: flex; flex-direction: column; align-items: center; justify-content: center;\n  gap: 1px;\n  text-decoration: none;\n  color: var(--ink-3);\n  font-size: 9.5px;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n  border-left: 2px solid transparent;\n  margin-right: 0;\n}\n.nav-item .g {\n  font-family: var(--mono); font-size: 16px;\n  color: var(--ink-2);\n  line-height: 1;\n}\n.nav-item .l { font-size: 9.5px; color: var(--ink-3); }\n.nav-item:hover { background: var(--bg-sunk); color: var(--ink); }\n.nav-item:hover .g { color: var(--ink); }\n.nav-item.active {\n  background: var(--bg);\n  border-left-color: var(--accent);\n}\n.nav-item.active .g { color: var(--ink); }\n.nav-item.active .l { color: var(--ink); font-weight: 500; }\n.nav-item.soon { opacity: .55; }\n.nav-item .badge {\n  position: absolute; top: 4px; right: 4px;\n  font-family: var(--mono); font-size: 8.5px;\n  color: var(--ink-4);\n  border: 1px solid var(--rule);\n  border-radius: 2px;\n  padding: 0 3px;\n  background: var(--bg);\n  text-transform: lowercase;\n}\n\n/* ─────────── App shell ─────────── */\n.app {\n  display: grid;\n  grid-template-rows: 36px 44px 32px 1fr;\n  grid-template-columns: 1fr;\n  height: 100vh;\n  overflow: hidden;\n}\n.app[data-comments=\"1\"][data-audit=\"1\"] .body {\n  grid-template-columns: 1fr var(--rail-w-comments) var(--rail-w-audit);\n}\n.app[data-comments=\"1\"][data-audit=\"0\"] .body {\n  grid-template-columns: 1fr var(--rail-w-comments);\n}\n.app[data-comments=\"0\"][data-audit=\"1\"] .body {\n  grid-template-columns: 1fr var(--rail-w-audit);\n}\n.app[data-comments=\"0\"][data-audit=\"0\"] .body {\n  grid-template-columns: 1fr;\n}\n\n/* ─────────── Top bar (title strip) ─────────── */\n.titlebar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 12px;\n  border-bottom: 1px solid var(--rule);\n  background: var(--bg-elev);\n  font-size: 11.5px;\n  color: var(--ink-3);\n  letter-spacing: .02em;\n}\n.titlebar .brand {\n  font-weight: 600;\n  color: var(--ink);\n  letter-spacing: .04em;\n  font-size: 11.5px;\n  text-transform: uppercase;\n}\n.titlebar .crumb { color: var(--ink-3); }\n.titlebar .crumb b { color: var(--ink-2); font-weight: 500; }\n.titlebar .sep { color: var(--ink-4); }\n.titlebar .right { margin-left: auto; display: flex; align-items: center; gap: 14px; }\n.titlebar .stat { display: flex; gap: 6px; align-items: baseline; }\n.titlebar .stat .k { color: var(--ink-4); font-size: 10.5px; text-transform: uppercase; letter-spacing: .06em; }\n.titlebar .stat .v { font-family: var(--mono); font-size: 11.5px; color: var(--ink-2); font-feature-settings: 'tnum', 'zero'; }\n\n/* ─────────── Switcher row ─────────── */\n.switcher {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--rule);\n  background: var(--bg);\n  padding: 0 12px;\n  gap: 0;\n}\n.sw {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 100%;\n  padding: 0 14px;\n  border-right: 1px solid var(--rule-soft);\n  cursor: pointer;\n  position: relative;\n}\n.sw:first-child { padding-left: 0; }\n.sw:hover { background: var(--bg-sunk); }\n.sw .lbl {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: .08em;\n  color: var(--ink-4);\n}\n.sw .val {\n  font-size: 13px;\n  color: var(--ink);\n  font-weight: 500;\n}\n.sw .val .meta {\n  color: var(--ink-3);\n  font-weight: 400;\n  margin-left: 6px;\n  font-size: 11.5px;\n  font-family: var(--mono);\n  font-feature-settings: 'tnum';\n}\n.sw .caret { color: var(--ink-4); margin-left: 2px; }\n\n.switcher .actions { margin-left: auto; display: flex; align-items: center; gap: 4px; }\n.iconbtn {\n  display: inline-flex; align-items: center; gap: 6px;\n  height: 26px; padding: 0 9px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  font-size: 11.5px;\n  color: var(--ink-2);\n}\n.iconbtn:hover { background: var(--bg-sunk); border-color: var(--rule-soft); }\n.iconbtn .kbd {\n  font-family: var(--mono); font-size: 10px;\n  color: var(--ink-4);\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  padding: 1px 4px;\n  background: var(--bg-elev);\n}\n\n/* ─────────── Diff summary bar ─────────── */\n.diffbar {\n  display: flex;\n  align-items: stretch;\n  border-bottom: 1px solid var(--rule);\n  background: var(--bg-elev);\n  font-size: 11.5px;\n}\n.diffbar .pill {\n  display: flex; align-items: center; gap: 7px;\n  padding: 0 14px;\n  border-right: 1px solid var(--rule-soft);\n  cursor: pointer;\n  color: var(--ink-3);\n  white-space: nowrap;\n  transition: background .08s;\n}\n.diffbar .pill:hover { background: var(--bg-sunk); }\n.diffbar .pill[aria-pressed=\"true\"] {\n  color: var(--ink);\n  background: var(--bg);\n  box-shadow: inset 0 -2px 0 var(--ink);\n}\n.diffbar .pill .dot {\n  width: 7px; height: 7px; border-radius: 50%;\n  background: var(--ink-4);\n}\n.diffbar .pill.is-diff   .dot { background: var(--diff); }\n.diffbar .pill.is-match  .dot { background: var(--match); }\n.diffbar .pill.is-over   .dot { background: var(--override); }\n.diffbar .pill .n {\n  font-family: var(--mono); font-size: 11px;\n  font-feature-settings: 'tnum';\n  color: var(--ink-2);\n  margin-left: 1px;\n}\n.diffbar .summary {\n  display: flex; align-items: center; gap: 10px;\n  padding: 0 14px;\n  margin-left: auto;\n  color: var(--ink-3);\n  border-left: 1px solid var(--rule-soft);\n}\n.diffbar .summary b { color: var(--ink); font-weight: 500; }\n.diffbar .summary .jump {\n  display: inline-flex; align-items: center; gap: 4px;\n  font-family: var(--mono); font-size: 10.5px; font-feature-settings: 'tnum';\n  color: var(--accent);\n  padding: 2px 6px;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  background: var(--bg);\n}\n.diffbar .summary .jump:hover { background: var(--bg-sunk); }\n.diffbar .search {\n  display: flex; align-items: center; gap: 6px;\n  padding: 0 12px;\n  border-left: 1px solid var(--rule-soft);\n}\n.diffbar .search input {\n  background: transparent;\n  border: 0;\n  outline: 0;\n  width: 160px;\n  font-size: 11.5px;\n  color: var(--ink);\n}\n.diffbar .search input::placeholder { color: var(--ink-4); }\n\n/* ─────────── Body / main + rails ─────────── */\n.body {\n  display: grid;\n  height: 100%;\n  overflow: hidden;\n  border-top: 0;\n}\n.main {\n  overflow: auto;\n  background: var(--bg);\n  position: relative;\n}\n.rail {\n  border-left: 1px solid var(--rule);\n  background: var(--bg-elev);\n  overflow: auto;\n  display: flex; flex-direction: column;\n}\n.rail .rail-head {\n  position: sticky; top: 0;\n  background: var(--bg-elev);\n  border-bottom: 1px solid var(--rule);\n  padding: 10px 14px 8px;\n  display: flex; align-items: baseline; justify-content: space-between;\n  z-index: 2;\n}\n.rail .rail-head .t {\n  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-3);\n  font-weight: 600;\n}\n.rail .rail-head .c {\n  font-family: var(--mono); font-size: 10.5px; color: var(--ink-4);\n  font-feature-settings: 'tnum';\n}\n\n/* ─────────── Tables ─────────── */\n.tablewrap {\n  padding: 0 0 80px;\n}\n.table {\n  border-bottom: 1px solid var(--rule);\n}\n.table .thead {\n  position: sticky; top: 0;\n  z-index: 3;\n  display: grid;\n  grid-template-columns: 32px 1fr 160px 160px 170px 28px;\n  background: var(--bg-elev);\n  border-bottom: 1px solid var(--rule);\n  border-top: 1px solid var(--rule);\n  font-size: 10.5px;\n  text-transform: uppercase;\n  letter-spacing: .08em;\n  color: var(--ink-3);\n  height: 26px;\n}\n.table .thead > div {\n  display: flex; align-items: center;\n  padding: 0 10px;\n  border-right: 1px solid var(--rule-soft);\n}\n.table .thead > div:last-child { border-right: 0; }\n.table .thead .n { justify-content: flex-end; }\n\n.table .tcap {\n  display: flex; align-items: baseline; gap: 10px;\n  padding: 18px 14px 8px;\n  background: var(--bg);\n  position: sticky; top: 0;\n  z-index: 4;\n  border-top: 1px solid var(--rule);\n}\n.table:first-child .tcap { border-top: 0; }\n.table .tcap .num {\n  font-family: var(--mono);\n  font-size: 10.5px;\n  color: var(--ink-4);\n  font-feature-settings: 'tnum';\n  letter-spacing: .04em;\n}\n.table .tcap .name {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--ink);\n  letter-spacing: -.005em;\n}\n.table .tcap .meta {\n  margin-left: auto;\n  font-size: 11px;\n  color: var(--ink-3);\n  font-family: var(--mono);\n  font-feature-settings: 'tnum';\n}\n.table .tcap .meta .k { color: var(--ink-4); }\n\n/* ─── Row ─── */\n.row {\n  display: grid;\n  grid-template-columns: 32px 1fr 160px 160px 170px 28px;\n  align-items: center;\n  height: var(--row-h);\n  border-bottom: 1px solid var(--rule-soft);\n  position: relative;\n  cursor: default;\n  font-size: 12.5px;\n}\n.row:hover { background: var(--bg-sunk); }\n.row.selected { background: var(--bg-sunk); box-shadow: inset 2px 0 0 var(--accent); }\n\n.row > div {\n  padding: 0 10px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  border-right: 1px solid transparent;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.row .c-tw {\n  justify-content: center;\n  padding: 0;\n  color: var(--ink-4);\n}\n.row .c-name { color: var(--ink-2); font-size: 12.5px; }\n.row .c-name .lvl0 { color: var(--ink); font-weight: 500; }\n.row .c-num,\n.row .c-master,\n.row .c-diff {\n  font-family: var(--mono);\n  font-size: 13px;\n  font-feature-settings: 'tnum', 'zero';\n  font-variant-numeric: tabular-nums;\n  justify-content: flex-end;\n  color: var(--ink);\n  letter-spacing: -.005em;\n}\n.row .c-master { color: var(--ink-3); font-weight: 400; }\n.row .c-diff { font-size: 12px; }\n.row .c-diff .pct {\n  color: var(--ink-4);\n  font-size: 10.5px;\n  margin-left: 6px;\n  min-width: 48px;\n  text-align: right;\n  display: inline-block;\n}\n.row .c-act { padding: 0; justify-content: center; color: var(--ink-4); }\n.row .c-act .expand {\n  width: 18px; height: 18px;\n  display: inline-flex; align-items: center; justify-content: center;\n  border-radius: 3px;\n  color: var(--ink-3);\n  font-family: var(--mono);\n  font-size: 11px;\n}\n.row .c-act .expand:hover { background: var(--bg); color: var(--ink); }\n\n/* status: left bar + tint */\n.row.s-match { box-shadow: inset 2px 0 0 var(--match); }\n.row.s-match .c-num { color: var(--ink); }\n.row.s-match .c-diff { color: var(--match); }\n\n.row.s-diff { background: var(--diff-bg); box-shadow: inset 2px 0 0 var(--diff); }\n.row.s-diff:hover { background: color-mix(in oklab, var(--diff-bg) 70%, var(--bg-sunk)); }\n.row.s-diff .c-diff { color: var(--diff); font-weight: 500; }\n\n.row.s-over { background: var(--override-bg); box-shadow: inset 2px 0 0 var(--override); }\n.row.s-over:hover { background: color-mix(in oklab, var(--override-bg) 70%, var(--bg-sunk)); }\n.row.s-over .c-diff { color: var(--override); }\n\n/* tweak dot */\n.tw-dot {\n  width: 6px; height: 6px; border-radius: 50%;\n  background: var(--ink-4);\n}\n.tw-dot.match { background: var(--match); }\n.tw-dot.diff { background: var(--diff); }\n.tw-dot.over { background: var(--override); }\n\n.row .has-comment {\n  width: 14px; height: 14px;\n  display: inline-flex; align-items: center; justify-content: center;\n  border-radius: 2px;\n  color: var(--ink-3);\n  font-size: 10px;\n  margin-left: 2px;\n}\n.row .has-comment.on {\n  color: var(--accent);\n  background: color-mix(in oklab, var(--accent) 10%, transparent);\n}\n\n/* ─── Drilldown ─── */\n.tree {\n  background: var(--bg-elev);\n  border-bottom: 1px solid var(--rule-soft);\n  font-family: var(--mono);\n  font-feature-settings: 'tnum', 'zero';\n  font-size: 12px;\n}\n.tree-row {\n  display: grid;\n  grid-template-columns: 32px 1fr 160px 160px 170px 28px;\n  align-items: center;\n  height: 26px;\n  color: var(--ink-3);\n  border-bottom: 1px solid var(--rule-soft);\n}\n.tree-row:last-child { border-bottom: 0; }\n.tree-row > div {\n  padding: 0 10px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.tree-row .c-num,\n.tree-row .c-master,\n.tree-row .c-diff {\n  justify-content: flex-end;\n}\n.tree-row .lines {\n  color: var(--ink-4);\n  font-size: 11px;\n  letter-spacing: -.02em;\n}\n.tree-row .src {\n  display: inline-flex; align-items: center; gap: 8px;\n  color: var(--ink-2);\n}\n.tree-row .file {\n  display: inline-block;\n  padding: 1px 5px;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  background: var(--bg);\n  font-size: 10.5px;\n  color: var(--ink-2);\n  letter-spacing: .02em;\n}\n.tree-row .cell { color: var(--ink-3); font-size: 11.5px; }\n.tree-row .desc { color: var(--ink-3); font-family: var(--sans); font-size: 11.5px; margin-left: 4px; }\n.tree-row .c-num { color: var(--ink); }\n.tree-row .c-master { color: var(--ink-4); }\n.tree-row .c-diff { color: var(--ink-4); font-size: 11px; }\n.tree-row.t-diff .c-diff { color: var(--diff); }\n.tree-row .formula {\n  display: inline-flex; align-items: center; gap: 6px;\n  color: var(--ink-3);\n  font-size: 11.5px;\n}\n.tree-row .formula .op { color: var(--ink-4); }\n.tree-foot {\n  display: grid;\n  grid-template-columns: 32px 1fr 160px 160px 170px 28px;\n  height: 24px;\n  align-items: center;\n  font-size: 10.5px;\n  text-transform: uppercase;\n  letter-spacing: .08em;\n  color: var(--ink-4);\n  border-top: 1px dashed var(--rule);\n  background: var(--bg);\n}\n.tree-foot > div { padding: 0 10px; height: 100%; display: flex; align-items: center; }\n.tree-foot .lbl { justify-content: flex-end; color: var(--ink-3); }\n.tree-foot .v { font-family: var(--mono); font-feature-settings:'tnum'; color: var(--ink); justify-content: flex-end; font-size: 11.5px; text-transform: none; letter-spacing: 0; }\n\n/* ─── Comments rail ─── */\n.cmt {\n  padding: 10px 14px 12px;\n  border-bottom: 1px solid var(--rule-soft);\n  cursor: pointer;\n}\n.cmt:hover { background: var(--bg-sunk); }\n.cmt.active { background: var(--bg-sunk); box-shadow: inset 2px 0 0 var(--accent); }\n.cmt .top {\n  display: flex; align-items: baseline; justify-content: space-between;\n  margin-bottom: 4px;\n}\n.cmt .row-name {\n  font-size: 11.5px;\n  font-weight: 500;\n  color: var(--ink);\n  flex: 1;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.cmt .ts {\n  font-family: var(--mono); font-size: 10px; font-feature-settings: 'tnum';\n  color: var(--ink-4);\n  margin-left: 8px;\n}\n.cmt .body {\n  font-size: 11.5px; color: var(--ink-2); line-height: 1.5;\n  display: block; overflow: visible;\n  height: auto;\n}\n.cmt .ctx {\n  font-family: var(--mono); font-size: 10.5px; font-feature-settings: 'tnum';\n  color: var(--ink-3);\n  margin-top: 4px;\n  display: flex; gap: 8px; align-items: baseline;\n}\n.cmt .ctx .v { color: var(--ink-2); }\n.cmt-empty {\n  padding: 24px 14px;\n  font-size: 11.5px; color: var(--ink-4);\n  text-align: center;\n}\n\n/* ─── Audit rail ─── */\n.audit-empty {\n  padding: 24px 14px;\n  font-size: 11.5px; color: var(--ink-4);\n  text-align: center;\n  line-height: 1.6;\n}\n.audit-empty .kbd {\n  font-family: var(--mono); font-size: 10px;\n  color: var(--ink-3);\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  padding: 1px 5px;\n  background: var(--bg);\n}\n.audit {\n  padding: 12px 14px 16px;\n}\n.audit .h {\n  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);\n  font-weight: 600;\n  margin: 14px 0 6px;\n}\n.audit .h:first-child { margin-top: 0; }\n.audit .row-title {\n  font-size: 13px; color: var(--ink); font-weight: 500;\n  margin-bottom: 2px;\n  text-wrap: pretty;\n}\n.audit .row-val {\n  font-family: var(--mono); font-size: 18px; color: var(--ink);\n  font-feature-settings: 'tnum', 'zero';\n  letter-spacing: -.01em;\n  margin-bottom: 2px;\n}\n.audit .row-val.diff { color: var(--diff); }\n.audit .row-val.match { color: var(--match); }\n.audit .row-sub {\n  font-family: var(--mono); font-size: 11px; color: var(--ink-3);\n  font-feature-settings: 'tnum';\n}\n.audit .pathline {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 6px;\n  font-size: 11.5px;\n  padding: 4px 0;\n  border-bottom: 1px solid var(--rule-soft);\n  align-items: baseline;\n}\n.audit .pathline:last-child { border-bottom: 0; }\n.audit .pathline .lbl { color: var(--ink-3); font-family: var(--mono); font-size: 11px; }\n.audit .pathline .val { color: var(--ink); font-family: var(--mono); font-size: 11.5px; font-feature-settings: 'tnum'; text-align: right; }\n.audit .formline {\n  font-family: var(--mono); font-size: 11px;\n  color: var(--ink-2);\n  background: var(--bg);\n  border: 1px solid var(--rule-soft);\n  border-radius: 3px;\n  padding: 8px 10px;\n  line-height: 1.55;\n  font-feature-settings: 'tnum';\n  white-space: pre-wrap;\n}\n.audit .formline .op { color: var(--ink-4); }\n.audit .formline .file { color: var(--accent); }\n\n/* ─── Status footer ─── */\n.statusbar {\n  position: fixed; left: 0; right: 0; bottom: 0;\n  height: 22px;\n  display: flex; align-items: center;\n  font-family: var(--mono);\n  font-size: 10.5px;\n  color: var(--ink-3);\n  background: var(--bg-elev);\n  border-top: 1px solid var(--rule);\n  padding: 0 12px;\n  gap: 14px;\n  z-index: 50;\n  font-feature-settings: 'tnum';\n}\n.statusbar .sep { color: var(--ink-4); }\n.statusbar .right { margin-left: auto; display: flex; gap: 14px; }\n\n/* ─── BOLD variant overrides ─── */\n.app[data-variant=\"bold\"] {\n  --row-h: 30px;\n}\n.app[data-variant=\"bold\"] .row.s-match { box-shadow: inset 3px 0 0 var(--match); }\n.app[data-variant=\"bold\"] .row.s-diff  { box-shadow: inset 3px 0 0 var(--diff); }\n.app[data-variant=\"bold\"] .row.s-over  { box-shadow: inset 3px 0 0 var(--override); }\n.app[data-variant=\"bold\"] .table .thead {\n  background: var(--ink);\n  color: var(--bg);\n  border-color: var(--ink);\n}\n.app[data-variant=\"bold\"] .table .thead > div { border-right-color: rgba(255,255,255,.08); color: var(--bg-sunk); }\n.app[data-variant=\"bold\"] .row .c-num { font-weight: 500; }\n.app[data-variant=\"bold\"] .titlebar .brand { color: var(--ink); }\n.app[data-variant=\"bold\"] .table .tcap {\n  border-bottom: 1px solid var(--ink);\n}\n.app[data-variant=\"bold\"] .row { border-bottom: 1px solid var(--rule); }\n\n/* ─── Density switching ─── */\n.app[data-density=\"compact\"]  { --row-h: 24px; }\n.app[data-density=\"regular\"]  { --row-h: 28px; }\n.app[data-density=\"comfy\"]    { --row-h: 34px; }\n\n.app[data-density=\"compact\"] .row,\n.app[data-density=\"compact\"] .tree-row { font-size: 12px; }\n.app[data-density=\"compact\"] .row .c-num,\n.app[data-density=\"compact\"] .row .c-master { font-size: 12.5px; }\n.app[data-density=\"comfy\"]   .row .c-num,\n.app[data-density=\"comfy\"]   .row .c-master { font-size: 13.5px; }\n\n/* ─── Misc ─── */\n.scroll-shadow {\n  position: sticky; top: 0; height: 0; pointer-events: none;\n}\n.kbd {\n  font-family: var(--mono); font-size: 10px;\n  color: var(--ink-3);\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  padding: 1px 4px;\n  background: var(--bg);\n  display: inline-block;\n}\n\n/* ─────────── Upload page ─────────── */\n.upload-page {\n  display: grid;\n  grid-template-rows: 36px auto 1fr;\n  height: 100vh;\n  overflow: hidden;\n}\n.upload-body {\n  overflow: auto;\n  padding: 0 0 60px;\n  background: var(--bg);\n}\n.upload-section {\n  border-bottom: 1px solid var(--rule);\n}\n.us-head {\n  display: flex; align-items: baseline; gap: 12px;\n  padding: 18px 20px 10px;\n  background: var(--bg);\n}\n.us-head .num {\n  font-family: var(--mono); font-size: 10.5px; color: var(--ink-4); font-feature-settings: 'tnum';\n  letter-spacing: .04em;\n}\n.us-head .name {\n  font-size: 13.5px; font-weight: 600; color: var(--ink); letter-spacing: -.005em;\n}\n.us-head .sub {\n  font-size: 11.5px; color: var(--ink-3);\n}\n.us-head .meta {\n  margin-left: auto;\n  font-family: var(--mono); font-size: 11px; color: var(--ink-3);\n  font-feature-settings: 'tnum';\n}\n.us-head .meta b { color: var(--ink); font-weight: 500; }\n\n.slot-table .thead {\n  display: grid;\n  grid-template-columns: 24px 110px 1fr 240px 70px 90px 130px 110px;\n  background: var(--bg-elev);\n  border-top: 1px solid var(--rule);\n  border-bottom: 1px solid var(--rule);\n  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-3);\n  height: 26px;\n}\n.slot-table .thead > div {\n  display: flex; align-items: center; padding: 0 10px;\n  border-right: 1px solid var(--rule-soft);\n}\n.slot-table .thead > div:last-child { border-right: 0; }\n.slot-row {\n  display: grid;\n  grid-template-columns: 24px 110px 1fr 240px 70px 90px 130px 110px;\n  align-items: center;\n  height: 36px;\n  border-bottom: 1px solid var(--rule-soft);\n  font-size: 12.5px;\n  position: relative;\n}\n.slot-row:hover { background: var(--bg-sunk); }\n.slot-row > div {\n  padding: 0 10px;\n  height: 100%;\n  display: flex; align-items: center;\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n}\n.slot-row .c-dot { padding: 0; justify-content: center; }\n.slot-row .c-dot .d {\n  width: 8px; height: 8px; border-radius: 50%;\n  background: var(--ink-4);\n}\n.slot-row.s-ok    .c-dot .d { background: var(--match); }\n.slot-row.s-warn  .c-dot .d { background: var(--override); }\n.slot-row.s-err   .c-dot .d { background: var(--diff); }\n.slot-row.s-empty .c-dot .d { background: transparent; border: 1px dashed var(--ink-4); }\n.slot-row.s-planned .c-dot .d { background: var(--ink-4); opacity: .35; }\n\n.slot-row.s-ok    { box-shadow: inset 2px 0 0 var(--match); }\n.slot-row.s-warn  { box-shadow: inset 2px 0 0 var(--override); background: var(--override-bg); }\n.slot-row.s-warn:hover { background: color-mix(in oklab, var(--override-bg) 70%, var(--bg-sunk)); }\n.slot-row.s-err   { box-shadow: inset 2px 0 0 var(--diff); background: var(--diff-bg); }\n.slot-row.s-empty { background: var(--bg); }\n.slot-row.s-planned { opacity: .55; background: repeating-linear-gradient(135deg, transparent 0 6px, var(--rule-soft) 6px 7px); }\n\n.slot-row .c-name {\n  font-family: var(--mono); font-size: 12px; font-feature-settings: 'tnum';\n  color: var(--ink); font-weight: 500;\n  gap: 8px;\n}\n.slot-row .req-tag {\n  font-family: var(--mono); font-size: 9.5px;\n  color: var(--ink-4);\n  border: 1px solid var(--rule);\n  border-radius: 2px;\n  padding: 1px 4px;\n  text-transform: uppercase;\n  letter-spacing: .04em;\n}\n.slot-row .req-tag.req { color: var(--diff); border-color: var(--diff); }\n\n.slot-row .c-desc { color: var(--ink-2); font-size: 12px; }\n.slot-row .c-file {\n  font-family: var(--mono); font-size: 11.5px; font-feature-settings: 'tnum';\n  color: var(--ink-2);\n}\n.slot-row .c-file.empty { color: var(--ink-4); font-style: italic; font-family: var(--sans); }\n.slot-row .c-size,\n.slot-row .c-sheets,\n.slot-row .c-mod {\n  font-family: var(--mono); font-size: 11px; font-feature-settings: 'tnum';\n  color: var(--ink-3);\n}\n.slot-row .c-size { justify-content: flex-end; }\n.slot-row .c-sheets { color: var(--ink-2); }\n\n.slot-row .c-actions {\n  padding: 0 8px;\n  justify-content: flex-end;\n  gap: 4px;\n}\n.slot-row .c-actions button {\n  padding: 3px 8px;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  font-size: 10.5px;\n  color: var(--ink-2);\n  background: var(--bg);\n  font-family: var(--sans);\n}\n.slot-row .c-actions button:hover { background: var(--bg-sunk); border-color: var(--ink-3); color: var(--ink); }\n.slot-row .c-actions button.primary {\n  border-color: var(--accent); color: var(--accent);\n}\n.slot-row .warn-msg {\n  margin-left: 8px;\n  font-size: 10.5px;\n  color: var(--override);\n  font-family: var(--mono);\n  font-feature-settings: 'tnum';\n}\n.slot-row .err-msg {\n  margin-left: 8px;\n  font-size: 10.5px;\n  color: var(--diff);\n  font-family: var(--mono);\n}\n\n/* Master block */\n.master-block {\n  display: grid;\n  grid-template-columns: 32px 1fr 200px 200px;\n  align-items: center;\n  margin: 0 20px 18px;\n  padding: 14px 16px;\n  background: var(--bg-elev);\n  border: 1px solid var(--rule);\n  border-left: 3px solid var(--accent);\n  border-radius: 3px;\n  gap: 12px;\n}\n.master-block .glyph {\n  font-family: var(--mono); font-size: 18px; color: var(--accent);\n  text-align: center;\n}\n.master-block .name {\n  font-size: 13px; font-weight: 600; color: var(--ink);\n}\n.master-block .name .ver {\n  font-family: var(--mono); font-size: 11px; font-feature-settings: 'tnum';\n  color: var(--ink-3); margin-left: 8px;\n  font-weight: 400;\n}\n.master-block .sub {\n  font-size: 11.5px; color: var(--ink-3); margin-top: 2px;\n}\n.master-block .stats {\n  font-family: var(--mono); font-size: 11px; font-feature-settings: 'tnum';\n  color: var(--ink-3);\n  display: grid; gap: 2px;\n}\n.master-block .stats b { color: var(--ink); font-weight: 500; }\n.master-block .acts {\n  display: flex; gap: 6px; justify-content: flex-end;\n}\n.master-block .acts button {\n  padding: 6px 12px;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  font-size: 11.5px;\n  color: var(--ink-2);\n  background: var(--bg);\n}\n.master-block .acts button.primary {\n  border-color: var(--accent); color: var(--accent);\n}\n.master-block .acts button:hover { background: var(--bg-sunk); }\n\n/* Rates panel — общий справочник на период */\n.rates-panel { margin: 0 20px; border: 1px solid var(--rule); background: var(--bg-elev); }\n.rp-head {\n  display: flex; align-items: center; gap: 14px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--rule);\n  background: linear-gradient(180deg, var(--bg) 0%, var(--bg-elev) 100%);\n}\n.rp-h1 { font-weight: 600; color: var(--ink); font-size: 13px; }\n.rp-h2 { color: var(--ink-3); font-size: 11.5px; font-family: var(--mono); }\n.rp-actions { margin-left: auto; display: flex; gap: 6px; }\n.rp-actions button {\n  height: 26px; padding: 0 10px;\n  background: var(--bg); border: 1px solid var(--rule);\n  font-size: 11px; color: var(--ink-2); cursor: pointer;\n  font-family: var(--mono);\n}\n.rp-actions button:hover { background: var(--bg-sunk); }\n.rp-actions button.primary { background: var(--ink); color: var(--bg); border-color: var(--ink); }\n.rates-wide .rwh,\n.rates-wide .rwr {\n  display: grid;\n  grid-template-columns: 64px 1.4fr 90px 90px 80px 80px 80px 80px 1fr 100px;\n}\n.rates-wide .rwh {\n  background: var(--bg);\n  border-bottom: 1px solid var(--rule);\n  height: 26px;\n  font-size: 10px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-4);\n}\n.rates-wide .rwh > div { display: flex; align-items: center; padding: 0 10px; border-right: 1px solid var(--rule-soft); }\n.rates-wide .rwh > div.n { justify-content: flex-end; }\n.rates-wide .rwr {\n  height: 34px;\n  border-bottom: 1px solid var(--rule-soft);\n  align-items: center;\n  font-size: 12.5px;\n}\n.rates-wide .rwr:last-child { border-bottom: 0; }\n.rates-wide .rwr:hover { background: var(--bg-sunk); }\n.rates-wide .rwr > div { padding: 0 10px; height: 100%; display: flex; align-items: center; border-right: 1px solid var(--rule-soft); }\n.rates-wide .rwr > div:last-child { border-right: 0; }\n.rates-wide .rwr .code { font-family: var(--mono); font-weight: 600; color: var(--ink); }\n.rates-wide .rwr .name { color: var(--ink-2); gap: 8px; }\n.rates-wide .rwr .name .yoy { font-family: var(--mono); font-size: 10.5px; }\n.rates-wide .rwr .v {\n  font-family: var(--mono); font-feature-settings: 'tnum'; font-size: 12.5px;\n  color: var(--ink); justify-content: flex-end;\n}\n.rates-wide .rwr .v.curr { font-weight: 600; }\n.rates-wide .rwr .v.hist { color: var(--ink-4); font-size: 11.5px; }\n.rates-wide .rwr .src { font-size: 11px; color: var(--ink-3); }\n.rates-wide .rwr .lock { font-size: 10.5px; color: var(--ink-3); font-family: var(--mono); }\n.rates-wide .rwr.editable .v.curr {\n  border-bottom: 1px dashed var(--override);\n  color: var(--override);\n}\n.rates-wide .rwr.editable .lock { color: var(--override); }\n.rp-foot {\n  display: flex; align-items: center; gap: 8px;\n  padding: 8px 16px;\n  border-top: 1px solid var(--rule);\n  background: var(--bg);\n  font-size: 11px; color: var(--ink-3);\n  font-family: var(--mono); font-feature-settings: 'tnum';\n}\n.rp-foot b { color: var(--ink-2); font-weight: 500; }\n.rp-foot .sep { color: var(--ink-4); }\n.rp-foot .meta { margin-left: auto; color: var(--ink-4); }\n\n/* Cluster picker on Upload — bigger, cluster grid */\n.cluster-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1px;\n  background: var(--rule);\n  border-top: 1px solid var(--rule);\n  border-bottom: 1px solid var(--rule);\n}\n.cluster-card {\n  padding: 12px 14px;\n  background: var(--bg);\n  cursor: pointer;\n  border-left: 2px solid transparent;\n}\n.cluster-card:hover { background: var(--bg-sunk); }\n.cluster-card.active { background: var(--bg-elev); border-left-color: var(--accent); }\n.cluster-card .top {\n  display: flex; justify-content: space-between; align-items: baseline;\n  margin-bottom: 4px;\n}\n.cluster-card .label {\n  font-family: var(--mono); font-size: 12px; font-weight: 600;\n  color: var(--ink);\n  font-feature-settings: 'tnum';\n}\n.cluster-card .progress {\n  font-family: var(--mono); font-size: 10.5px; font-feature-settings: 'tnum';\n  color: var(--ink-3);\n}\n.cluster-card.complete .progress { color: var(--match); }\n.cluster-card.partial  .progress { color: var(--override); }\n.cluster-card .company { font-size: 11.5px; color: var(--ink-2); }\n.cluster-card .period { font-size: 10.5px; color: var(--ink-4); font-family: var(--mono); }\n.cluster-card .bar {\n  height: 2px; background: var(--rule); margin-top: 8px;\n  overflow: hidden;\n}\n.cluster-card .bar-fill {\n  height: 100%; background: var(--match);\n}\n.cluster-card.partial .bar-fill { background: var(--override); }\n\n/* Defaults strip */\n.defaults-strip {\n  margin: 0 20px;\n  padding: 12px 14px;\n  background: var(--bg-elev);\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  font-size: 12px;\n}\n.defaults-strip label {\n  display: flex; align-items: center; gap: 8px;\n  color: var(--ink-2);\n  cursor: pointer;\n}\n.defaults-strip input[type=\"checkbox\"] {\n  width: 14px; height: 14px;\n  accent-color: var(--accent);\n}\n.defaults-strip .meta {\n  margin-left: auto;\n  font-family: var(--mono); font-size: 10.5px; color: var(--ink-3);\n  font-feature-settings: 'tnum';\n}\n\n/* Drop zone overlay */\n.drop-overlay {\n  position: fixed; inset: 0;\n  background: color-mix(in oklab, var(--accent) 14%, var(--bg) 50%);\n  z-index: 200;\n  display: flex; align-items: center; justify-content: center;\n  pointer-events: none;\n  animation: dropFade .14s ease-out;\n}\n@keyframes dropFade { from { opacity: 0; } to { opacity: 1; } }\n.drop-overlay::before {\n  content: ''; position: absolute; inset: 24px;\n  border: 2.5px dashed var(--accent);\n  border-radius: 6px;\n  background: color-mix(in oklab, var(--accent) 4%, var(--bg-elev));\n}\n.drop-overlay .drop-card {\n  position: relative;\n  text-align: center;\n  padding: 32px 56px;\n  background: var(--bg-elev);\n  border: 1px solid var(--rule);\n  border-radius: 4px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, .14);\n  max-width: 520px;\n}\n.drop-overlay .dco-glyph {\n  font-family: var(--mono);\n  font-size: 56px; line-height: 1;\n  color: var(--accent);\n  margin-bottom: 14px;\n}\n.drop-overlay .dco-title {\n  font-size: 18px; font-weight: 600; color: var(--ink);\n  letter-spacing: -.005em;\n  margin-bottom: 6px;\n}\n.drop-overlay .dco-sub {\n  font-size: 12.5px; color: var(--ink-3); line-height: 1.55;\n}\n.drop-overlay .dco-sub b { color: var(--ink); font-weight: 500; font-family: var(--mono); }\n\n/* File preview popover (Upload) */\n.file-pop {\n  position: fixed;\n  z-index: 150;\n  background: var(--bg-elev);\n  border: 1px solid var(--rule);\n  border-radius: 4px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, .14), 0 2px 8px rgba(0, 0, 0, .08);\n  pointer-events: none;\n  animation: fpFade .12s ease-out;\n}\n@keyframes fpFade {\n  from { opacity: 0; transform: translateY(-3px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.file-pop .fph {\n  display: flex; align-items: baseline; gap: 12px;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--rule);\n  background: var(--bg);\n  border-radius: 4px 4px 0 0;\n}\n.file-pop .fph .fname {\n  font-family: var(--mono); font-size: 12px; font-weight: 600;\n  color: var(--ink); font-feature-settings: 'tnum';\n}\n.file-pop .fph .fmeta {\n  margin-left: auto;\n  font-size: 10.5px; color: var(--ink-3);\n  font-family: var(--mono); font-feature-settings: 'tnum';\n}\n.file-pop .fph .fmeta b { color: var(--ink); font-weight: 500; }\n.file-pop .fwarn {\n  display: flex; align-items: center; gap: 8px;\n  padding: 6px 14px;\n  background: color-mix(in oklab, var(--diff) 10%, var(--bg-elev));\n  border-bottom: 1px solid var(--rule-soft);\n  font-size: 11px;\n  color: var(--diff);\n}\n.file-pop .fwarn .dot {\n  width: 6px; height: 6px; border-radius: 50%;\n  background: var(--diff);\n}\n.file-pop .fgrid {\n  width: 100%;\n  border-collapse: collapse;\n  font-feature-settings: 'tnum';\n}\n.file-pop .fgrid th, .file-pop .fgrid td {\n  padding: 5px 10px;\n  border-right: 1px solid var(--rule-soft);\n  border-bottom: 1px solid var(--rule-soft);\n  font-size: 11px;\n  color: var(--ink-2);\n  font-family: var(--mono);\n  white-space: nowrap;\n  text-align: left;\n}\n.file-pop .fgrid th:last-child, .file-pop .fgrid td:last-child { border-right: 0; }\n.file-pop .fgrid tbody tr:last-child td { border-bottom: 0; }\n.file-pop .fgrid th {\n  background: var(--bg);\n  color: var(--ink-4);\n  font-size: 10px; font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: .05em;\n}\n.file-pop .fgrid td.rh {\n  color: var(--ink-4);\n  font-size: 10px;\n  width: 36px;\n  background: var(--bg);\n  text-align: right;\n}\n.file-pop .fgrid td.n { text-align: right; color: var(--ink); }\n.file-pop .fpf {\n  display: flex; align-items: center;\n  padding: 8px 14px;\n  border-top: 1px solid var(--rule);\n  font-size: 10.5px;\n  color: var(--ink-3);\n  font-family: var(--mono);\n  font-feature-settings: 'tnum';\n  background: var(--bg);\n  border-radius: 0 0 4px 4px;\n}\n\n/* scrollbar - ledger feel */\n.main::-webkit-scrollbar, .rail::-webkit-scrollbar { width: 10px; height: 10px; }\n.main::-webkit-scrollbar-thumb, .rail::-webkit-scrollbar-thumb {\n  background: var(--rule);\n  border: 2px solid var(--bg);\n  border-radius: 6px;\n}\n.main::-webkit-scrollbar-track, .rail::-webkit-scrollbar-track { background: transparent; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
